<app-header></app-header>

<body class="min-h-screen min-w-full p-4 tema-claro">

  <!-- Spinner global -->
  <div *ngIf="isSubmitting" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
    <div class="h-12 w-12 animate-spin rounded-full border-4 border-gray-300"
      style="border-top-color: var(--brand-primary)"></div>
  </div>

  <div [class]="stage === 'pagamento' ? 'max-w-5xl mx-auto' : 'max-w-3xl mx-auto'">

    <!-- ── Cabeçalho ── -->
    <div class="mb-5 flex justify-between items-center">
      <h2 class="text-xl font-semibold" style="color: var(--tx)">Abrir Atendimento</h2>
      <button (click)="voltarDashboard()"
        class="flex items-center gap-2 px-3 py-1 border rounded-lg font-medium text-sm"
        style="border-color: var(--brand-primary); color: var(--brand-primary)"
        onmouseover="this.style.backgroundColor='var(--brand-primary)';this.style.color='white'"
        onmouseout="this.style.backgroundColor='transparent';this.style.color='var(--brand-primary)'">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955a1.126 1.126 0 0 1 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
        </svg>
        Dashboard
      </button>
    </div>

    <!-- ── Indicador de etapas (visível nos steps 1-5) ── -->
    <div *ngIf="stage === 'step1' || stage === 'step2' || stage === 'step3' || stage === 'pagamento'"
      class="flex items-center mb-5">
      <ng-container *ngFor="let step of [1,2,3,4,5]; let i = index">
        <div class="flex items-center gap-2">
          <div class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold"
            [style.background-color]="stepAtivo(step) ? (step === 5 && stepAtual(step) ? 'var(--brand-secondary)' : 'var(--brand-primary)') : '#E5DFD4'"
            [style.color]="stepAtivo(step) ? 'white' : '#4A5D6B'">
            <svg *ngIf="stepCompleto(step)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              stroke-width="2.5" stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
            </svg>
            <span *ngIf="!stepCompleto(step)">{{ step }}</span>
          </div>
          <span class="text-sm font-medium hidden sm:inline"
            [style.color]="stepAtual(step) ? (step === 5 ? 'var(--brand-secondary)' : 'var(--brand-primary)') : '#4A5D6B'">
            {{ step === 1 ? 'Dados' : step === 2 ? 'Procedimentos' : step === 3 ? 'Confirmação' : step === 4 ?
            'Pagamento' : 'Concluído' }}
          </span>
        </div>
        <div *ngIf="i < 4" class="flex-1 h-0.5 mx-3"
          [style.background-color]="linhaAtiva(i) ? 'var(--brand-primary)' : '#E5DFD4'"></div>
      </ng-container>
    </div>

    <!-- ── Mensagem de erro ── -->
    <div *ngIf="erroMensagem" class="rounded-xl px-4 py-3 mb-4 text-sm flex items-start gap-2"
      style="background-color: #fde8e8; color: #d34747">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#d34747"
        class="size-5 shrink-0 mt-0.5">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
      </svg>
      {{ erroMensagem }}
    </div>

    <!-- ════════════════════════════════════════════════════════════
         BUSCA DE PACIENTE (Senha Express)
         ════════════════════════════════════════════════════════════ -->
    <div *ngIf="stage === 'busca-paciente'" class="flex flex-col gap-4">
      <div class="bg-white dark:bg-[#10283A]"
           style="border-radius: 18px; border: 1px solid #EFE9DD; box-shadow: 0 2px 10px -6px rgba(64,40,112,.28)">

        <div class="modal-v2-topo">
          <div class="flex-1 min-w-0">
            <p class="modal-v2-eyebrow">Senha Express</p>
            <h3 class="modal-v2-titulo">Buscar paciente</h3>
            <p class="modal-v2-sub">Informe o CPF ou nome do paciente para abrir o atendimento.</p>
          </div>
        </div>

        <div class="px-7 pb-6">
          <div class="relative">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="2" stroke="currentColor" class="campo-busca-icone size-4">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/>
            </svg>
            <input type="text" [(ngModel)]="buscaPacienteQuery" (input)="onBuscaPacienteInput()"
                   placeholder="Digite o CPF ou nome do paciente (mín. 3 caracteres)"
                   class="campo-busca" autofocus />
            <div class="campo-busca-acao">
              <div *ngIf="isLoadingBuscaPaciente" class="animate-spin rounded-full h-4 w-4 border-b-2"
                   style="border-color: var(--brand-primary)"></div>
              <button *ngIf="!isLoadingBuscaPaciente && buscaPacienteQuery" type="button"
                      (click)="buscaPacienteQuery = ''; buscaPacienteResultados = []"
                      title="Limpar busca" style="color: var(--brand-muted)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" class="size-4">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
                </svg>
              </button>
            </div>
          </div>

          <div *ngIf="buscaPacienteResultados.length > 0" class="mt-4 flex flex-col gap-2">
            <p style="font-size: 11px; font-weight: 600; color: var(--tx-2)">
              {{ buscaPacienteResultados.length }} {{ buscaPacienteResultados.length === 1 ? 'paciente encontrado' : 'pacientes encontrados' }}
            </p>
            <button *ngFor="let p of buscaPacienteResultados" type="button"
                    (click)="selecionarPacienteBusca(p)"
                    class="motivo-pausa paciente-busca flex items-center gap-3 text-left px-4 py-3">
              <span class="flex-1 min-w-0">
                <span class="block truncate dark:text-white" style="font-size: 14px; font-weight: 700; color: var(--tx)">
                  {{ p.nmPessoaFisica }}
                </span>
                <span class="sub-paciente block">Cód. {{ p.cdPessoaFisica }} · CPF {{ formatarCpf(p.nrCpf) }}</span>
              </span>
              <span class="paciente-busca-acao shrink-0">Selecionar</span>
            </button>
          </div>

          <div *ngIf="!isLoadingBuscaPaciente && buscaPacienteQuery.trim().length >= 3 && buscaPacienteResultados.length === 0"
               class="mt-4 flex flex-col items-center text-center rounded-xl py-6 px-4" style="border: 1px dashed var(--flua-borda)">
            <p style="font-size: 14px; font-weight: 600; color: var(--tx-2)" class="dark:text-gray-200">Nenhum paciente encontrado</p>
            <p style="font-size: 12px; color: var(--tx-2); margin-top: 2px">Confira o CPF ou cadastre o paciente agora.</p>
            <button type="button" (click)="abrirCadastroPaciente('express', buscaPacienteQuery)"
                    class="mt-3 px-5 text-white"
                    style="height: 40px; border-radius: 10px; font-size: 13px; font-weight: 700; background-color: var(--brand-secondary)">
              Cadastrar paciente
            </button>
          </div>
        </div>
      </div>

      <div class="flex justify-start">
        <button type="button" (click)="voltarDashboard()" class="chip-v2" style="height: 36px; padding: 0 16px">
          ← Voltar ao dashboard
        </button>
      </div>
    </div>

    <!-- ════════════════════════════════════════════════════════════
         TELA DE VALIDAÇÃO CADASTRAL — EDITAR CADASTRO
         ════════════════════════════════════════════════════════════ -->
    <div *ngIf="stage === 'validacao'" class="flex flex-col gap-4">

      <!-- Card Editar Cadastro -->
      <div class="rounded-2xl overflow-hidden shadow-sm" style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">

        <!-- Cabeçalho -->
        <div class="px-5 py-4 flex items-center gap-2" style="border-bottom: 1px solid var(--flua-borda)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="var(--brand-primary)" class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125" />
          </svg>
          <p class="font-semibold text-sm" style="color: var(--tx)">Editar Cadastro</p>
        </div>

        <!-- Spinner carregando -->
        <div *ngIf="isLoadingPatient" class="flex items-center gap-3 px-5 py-6 text-sm" style="color: var(--tx-2)">
          <div class="h-4 w-4 animate-spin rounded-full border-2 border-gray-300"
            style="border-top-color: var(--brand-primary)"></div>
          Carregando dados do paciente...
        </div>

        <!-- Senha com CPF que não existe no TASY -->
        <div *ngIf="pacienteSemCadastro" class="mx-5 mt-5 rounded-xl px-4 py-3 flex items-center justify-between gap-3 flex-wrap"
          style="background-color: #fff4e0; color: #8a5a0c">
          <span class="text-sm">Paciente sem cadastro no sistema{{ selectedPassword?.cpf ? ' (CPF ' + selectedPassword.cpf + ')' : '' }}.</span>
          <button type="button" (click)="abrirCadastroPaciente('senha', selectedPassword?.cpf ?? '')"
            class="px-4 py-2 rounded-lg text-white text-xs font-semibold" style="background-color: var(--brand-secondary)">
            Cadastrar paciente
          </button>
        </div>

        <!-- Formulário -->
        <div *ngIf="!isLoadingPatient" class="px-5 py-5 flex flex-col gap-5 text-sm">

          <!-- Linha CPF + Vincular Responsável -->
          <div class="flex items-center justify-between gap-3 flex-wrap">
            <!-- CPF chip -->
            <div class="flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs"
              style="background-color: var(--chip-bg); color: var(--chip-tx)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z" />
              </svg>
              <span class="font-medium">CPF (não editável)</span>
              <span class="font-bold">{{ formatarCpf(selectedPassword?.cpf) }}</span>
            </div>

            <!-- Botão Vincular Resp. Legal (abre modal igual ao PRE) -->
            <button type="button" (click)="abrirModalResponsavel()"
              class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors"
              [style.border]="respLegalSalvo ? '1px solid #00AC70' : '1.5px dashed var(--brand-primary)'"
              [style.background-color]="respLegalSalvo ? '#e8f5ee' : 'transparent'"
              [style.color]="respLegalSalvo ? '#1f6f43' : 'var(--brand-primary)'">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
              </svg>
              {{ respLegalSalvo ? 'Resp. Legal Vinculado' : 'Vincular Resp. Legal' }}
              <span *ngIf="ehMenorDeIdade && !respLegalSalvo" class="ml-0.5 px-1 rounded text-xs font-bold"
                style="background-color: #fff8e1; color: #8a6900">*</span>
            </button>

            <button *ngIf="selectedPassword?.personId" type="button" data-acao="termos" (click)="mostrarTermos = true"
              class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium"
              style="border: 1px solid var(--flua-borda); color: var(--brand-primary)">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><path d="M9 13h6M9 17h4"/>
              </svg>
              Termos
            </button>
          </div>

          <!-- Card de status do responsável legal (quando salvo) -->
          <div *ngIf="respLegalSalvo && respLegalForm.nmContato" class="rounded-xl p-4 flex flex-col gap-2"
            style="background-color: var(--flua-fundo); border: 1px solid var(--flua-borda)">
            <div class="flex items-center justify-between">
              <p class="text-xs font-semibold uppercase" style="color: var(--brand-primary); letter-spacing: .05em">
                Responsável Legal
              </p>
              <button type="button" (click)="abrirModalResponsavel()" class="text-xs font-medium"
                style="color: var(--brand-primary)">Editar</button>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-2 rounded-lg p-3"
              style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
              <div class="flex flex-col gap-0.5">
                <span class="text-xs font-medium" style="color: var(--tx-2)">Nome</span>
                <span class="text-sm font-semibold" style="color: var(--tx)">{{ respLegalForm.nmContato }}</span>
              </div>
              <div class="flex flex-col gap-0.5">
                <span class="text-xs font-medium" style="color: var(--tx-2)">CPF</span>
                <span class="text-sm" style="color: var(--tx)">{{ formatarCpf(respLegalForm.nrCpf) }}</span>
              </div>
              <div class="flex flex-col gap-0.5">
                <span class="text-xs font-medium" style="color: var(--tx-2)">Telefone</span>
                <span class="text-sm" style="color: var(--tx)">({{ respLegalForm.nrDdd }}) {{ respLegalForm.nrTelefone
                  }}</span>
              </div>
              <div class="flex flex-col gap-0.5">
                <span class="text-xs font-medium" style="color: var(--tx-2)">E-mail</span>
                <span class="text-sm" style="color: var(--tx)">{{ respLegalForm.dsEmail || '—' }}</span>
              </div>
              <div class="flex flex-col gap-0.5 md:col-span-2">
                <span class="text-xs font-medium" style="color: var(--tx-2)">Endereço</span>
                <span class="text-sm" style="color: var(--tx)">
                  {{ respLegalForm.dsEndereco }}{{ respLegalForm.nrEndereco ? ', ' + respLegalForm.nrEndereco : '' }}
                  — {{ respLegalForm.dsBairro }}, {{ respLegalForm.dsMunicipio }}/{{ respLegalForm.sgEstado }}
                </span>
              </div>
            </div>
          </div>

          <!-- Nome completo -->
          <div class="flex flex-col gap-1">
            <label class="text-xs font-medium flex items-center gap-1.5" style="color: var(--tx-2)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
              </svg>
              Nome completo
            </label>
            <input type="text" [(ngModel)]="nomeEditado" class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
              style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
          </div>

          <!-- Nome social -->
          <div class="flex flex-col gap-1">
            <label class="text-xs font-medium flex items-center gap-1.5" style="color: var(--tx-2)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
              </svg>
              Nome Social <span class="font-normal">(opcional)</span>
            </label>
            <input type="text" [(ngModel)]="socialNameEditado" placeholder="Como prefere ser chamado(a)..."
              class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
              style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
          </div>

          <!-- Nascimento + Sexo -->
          <div class="grid grid-cols-2 gap-4">
            <div class="flex flex-col gap-1">
              <label class="text-xs font-medium flex items-center gap-1.5" style="color: var(--tx-2)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="size-3.5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M12 8.25v-1.5m0 1.5c-1.355 0-2.697.056-4.024.166C6.845 8.51 6 9.473 6 10.608v2.513m6-4.871c1.355 0 2.697.056 4.024.166C17.155 8.51 18 9.473 18 10.608v2.513M15 8.25v-1.5m-6 1.5v-1.5m12 9.75-1.5.75a3.354 3.354 0 0 1-3 0 3.354 3.354 0 0 0-3 0 3.354 3.354 0 0 1-3 0 3.354 3.354 0 0 0-3 0 3.354 3.354 0 0 1-3 0L3 16.5m15-3.379a48.474 48.474 0 0 0-6-.371c-2.032 0-4.034.126-6 .371m12 0c.39.049.777.102 1.163.16 1.07.16 1.837 1.094 1.837 2.175v5.169c0 .621-.504 1.125-1.125 1.125H4.125A1.125 1.125 0 0 1 3 20.625v-5.17c0-1.08.768-2.014 1.837-2.174A47.78 47.78 0 0 1 6 13.12M12.265 3.11a.375.375 0 1 1-.53 0L12 2.845l.265.265Zm-3 0a.375.375 0 1 1-.53 0L9 2.845l.265.265Zm6 0a.375.375 0 1 1-.53 0L15 2.845l.265.265Z" />
                </svg>
                Nascimento
              </label>
              <input type="date" [(ngModel)]="nascimentoEditado"
                class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
                style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
            </div>
            <div class="flex flex-col gap-1">
              <label class="text-xs font-medium flex items-center gap-1.5" style="color: var(--tx-2)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="size-3.5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z" />
                </svg>
                Sexo
              </label>
              <select [(ngModel)]="generoEditado" class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
                style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)">
                <option value="">Selecione</option>
                <option value="M">Masculino</option>
                <option value="F">Feminino</option>
                <option value="I">Indefinido</option>
              </select>
            </div>
          </div>

          <!-- DDD + Celular + E-mail -->
          <div class="grid grid-cols-1 sm:grid-cols-[80px_1fr_1fr] gap-3 items-start">
            <div class="flex flex-col gap-1">
              <label class="text-xs font-medium flex items-center gap-1.5" style="color: var(--tx-2)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="size-3.5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                </svg>
                DDD
              </label>
              <input type="text" [value]="dddEditado" (input)="onDddInput($event)" placeholder="85" maxlength="2"
                class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
                [style.border-color]="telefoneErro ? '#d34747' : '#E5DFD4'"
                style="color: var(--tx); background-color: var(--cartao)" />
            </div>
            <div class="flex flex-col gap-1">
              <label class="text-xs font-medium" style="color: var(--tx-2)">Celular</label>
              <input type="text" [value]="celularEditado" (input)="onCelularInput($event)" placeholder="986450132"
                maxlength="9" class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
                [style.border-color]="telefoneErro ? '#d34747' : '#E5DFD4'"
                style="color: var(--tx); background-color: var(--cartao)" />
            </div>
            <div class="flex flex-col gap-1">
              <label class="text-xs font-medium flex items-center gap-1.5" style="color: var(--tx-2)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="size-3.5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                </svg>
                E-mail
              </label>
              <input type="email" [(ngModel)]="emailEditado" (ngModelChange)="emailErro = ''"
                placeholder="nome@dominio.com.br" [disabled]="semEmail"
                class="w-full rounded-lg border px-3 py-2 text-sm outline-none disabled:bg-gray-100 disabled:cursor-not-allowed"
                [style.border-color]="emailErro ? '#d34747' : '#E5DFD4'"
                style="color: var(--tx); background-color: var(--cartao)" />
              <label class="flex items-center gap-1.5 mt-1 cursor-pointer select-none">
                <input type="checkbox" [(ngModel)]="semEmail"
                  (ngModelChange)="semEmail && (emailEditado = ''); emailErro = ''"
                  class="w-3.5 h-3.5 rounded cursor-pointer" style="accent-color: var(--brand-primary)" />
                <span class="text-xs" style="color: var(--tx-2)">Não possui e-mail</span>
              </label>
            </div>
          </div>
          <p *ngIf="telefoneErro" class="text-xs -mt-3" style="color: #d34747">{{ telefoneErro }}</p>
          <p *ngIf="emailErro" class="text-xs -mt-3" style="color: #d34747">{{ emailErro }}</p>

          <!-- ENDEREÇO -->
          <div class="flex flex-col gap-3" style="border-top: 1px solid var(--flua-borda); padding-top: 16px">
            <p class="text-xs font-semibold uppercase flex items-center gap-1.5"
              style="color: var(--brand-primary); letter-spacing: .05em">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
              </svg>
              Endereço
            </p>

            <!-- CEP + Número -->
            <div class="grid grid-cols-2 gap-3">
              <div class="flex flex-col gap-1">
                <label class="text-xs font-medium" style="color: var(--tx-2)">CEP <span
                    style="color:#d34747">*</span></label>
                <div class="relative">
                  <input type="text" [value]="cepEditado" (input)="onCepInput($event); enderecoErro = ''"
                    placeholder="00000-000" maxlength="9"
                    class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
                    style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
                  <div *ngIf="isLoadingCep" class="absolute right-2 top-2.5">
                    <div class="h-4 w-4 animate-spin rounded-full border-2 border-gray-300"
                      style="border-top-color: var(--brand-primary)"></div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-1">
                <label class="text-xs font-medium" style="color: var(--tx-2)">Número <span
                    style="color:#d34747">*</span></label>
                <input type="text" [(ngModel)]="numeroEditado" (ngModelChange)="enderecoErro = ''" placeholder="Número"
                  class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
                  style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
              </div>
            </div>

            <!-- Logradouro -->
            <div class="flex flex-col gap-1">
              <label class="text-xs font-medium" style="color: var(--tx-2)">Logradouro <span
                  style="color:#d34747">*</span></label>
              <input type="text" [(ngModel)]="logradouroEditado" (ngModelChange)="enderecoErro = ''"
                placeholder="Rua, Av..." class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
                [style.border-color]="enderecoErro && !logradouroEditado.trim() ? '#d34747' : '#E5DFD4'"
                style="color: var(--tx); background-color: var(--cartao)" />
            </div>

            <!-- Complemento -->
            <div class="flex flex-col gap-1">
              <label class="text-xs font-medium" style="color: var(--tx-2)">Complemento</label>
              <input type="text" [(ngModel)]="complementoEditado" placeholder="Apto, Bloco..."
                class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
                style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
            </div>

            <!-- Bairro + Cidade -->
            <div class="grid grid-cols-2 gap-3">
              <div class="flex flex-col gap-1">
                <label class="text-xs font-medium" style="color: var(--tx-2)">Bairro <span
                    style="color:#d34747">*</span></label>
                <input type="text" [(ngModel)]="bairroEditado" (ngModelChange)="enderecoErro = ''" placeholder="Bairro"
                  class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
                  [style.border-color]="enderecoErro && !bairroEditado.trim() ? '#d34747' : '#E5DFD4'"
                  style="color: var(--tx); background-color: var(--cartao)" />
              </div>
              <div class="flex flex-col gap-1">
                <label class="text-xs font-medium" style="color: var(--tx-2)">Cidade <span
                    style="color:#d34747">*</span></label>
                <input type="text" [(ngModel)]="cidadeEditado" (ngModelChange)="enderecoErro = ''" placeholder="Cidade"
                  class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
                  [style.border-color]="enderecoErro && !cidadeEditado.trim() ? '#d34747' : '#E5DFD4'"
                  style="color: var(--tx); background-color: var(--cartao)" />
              </div>
            </div>

            <!-- Estado -->
            <div class="flex flex-col gap-1" style="max-width: 120px">
              <label class="text-xs font-medium" style="color: var(--tx-2)">Estado (UF)</label>
              <input type="text" [(ngModel)]="estadoEditado" (ngModelChange)="enderecoErro = ''" placeholder="CE"
                maxlength="2" class="w-full rounded-lg border px-3 py-2 text-sm outline-none uppercase"
                [style.border-color]="enderecoErro ? '#d34747' : '#E5DFD4'"
                style="color: var(--tx); background-color: var(--cartao)" />
            </div>

            <p *ngIf="enderecoErro" class="text-xs flex items-center gap-1.5" style="color: #d34747">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-3.5 shrink-0">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
              </svg>
              {{ enderecoErro }}
            </p>
          </div>

        </div>

        <!-- Botões -->
        <div class="px-5 py-4 flex justify-between items-center" style="border-top: 1px solid var(--flua-borda)">
          <button (click)="voltarDashboard()"
            class="px-4 py-2 rounded-lg border text-sm font-medium flex items-center gap-1.5"
            style="border-color: var(--flua-borda); color: var(--tx-2); background-color: transparent"
            onmouseover="this.style.backgroundColor='var(--brand-surface)'" onmouseout="this.style.backgroundColor='transparent'">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
            Cancelar
          </button>
          <button (click)="salvarEContinuar()" [disabled]="isSavingPatient || isLoadingPatient"
            class="px-5 py-2 rounded-lg text-white text-sm font-semibold flex items-center gap-2"
            style="background-color: var(--brand-primary)" onmouseover="this.style.backgroundColor='var(--brand-ink)'"
            onmouseout="this.style.backgroundColor='var(--brand-primary)'"
            [style.opacity]="(isSavingPatient || isLoadingPatient) ? '0.6' : '1'">
            <div *ngIf="isSavingPatient"
              class="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
            <svg *ngIf="!isSavingPatient" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              stroke-width="2" stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z" />
            </svg>
            {{ isSavingPatient ? 'Salvando...' : 'Salvar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ════════════════════════════════════════════════════════════
         STEP 1 — DADOS DO ATENDIMENTO
         ════════════════════════════════════════════════════════════ -->
    <div *ngIf="stage === 'step1'" class="flex flex-col gap-4">

      <!-- Card paciente -->
      <div class="rounded-2xl overflow-hidden shadow-sm" style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
        <div class="px-5 py-3 flex items-center justify-between" style="border-bottom: 1px solid var(--flua-borda)">
          <p class="font-semibold text-sm" style="color: var(--tx)">Paciente</p>
          <button (click)="abrirTrocarPaciente()"
            class="flex items-center gap-1 text-xs font-medium px-2 py-1 rounded-lg transition-colors"
            style="color: var(--brand-primary); border: 1px solid var(--flua-borda); background: transparent"
            onmouseover="this.style.backgroundColor='var(--brand-tint)'" onmouseout="this.style.backgroundColor='transparent'"
            title="CPF errado? Troque o paciente vinculado a esta senha">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="size-3.5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
            </svg>
            Trocar Paciente
          </button>
        </div>
        <div class="px-5 py-4 text-sm">
          <p class="font-semibold" style="color: var(--tx)">{{ selectedPassword?.name | titlecase }}</p>
          <p class="text-xs mt-0.5" style="color: var(--tx-2)">
            Código: {{ selectedPassword?.personId }} &nbsp;|&nbsp; {{ selectedPassword?.planDescription }}
          </p>
        </div>
      </div>

      <!-- Modal Trocar Paciente -->
      <div *ngIf="showTrocarPaciente"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
        <div class="bg-white rounded-2xl shadow-xl w-full max-w-sm mx-4 overflow-hidden">
          <!-- Header -->
          <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100">
            <div>
              <p class="font-semibold text-sm" style="color: var(--tx)">Trocar Paciente</p>
              <p class="text-xs mt-0.5" style="color: var(--tx-2)">
                Senha: <strong>{{ selectedPassword?.dsPassword }}</strong> —
                atual: {{ selectedPassword?.name | titlecase }}
              </p>
            </div>
            <button (click)="fecharTrocarPaciente()"
              class="p-1 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="size-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <!-- Body -->
          <div class="px-5 py-4 flex flex-col gap-3">
            <!-- Input busca -->
            <div class="relative">
              <input type="text" [(ngModel)]="trocarCpfQuery" (input)="onTrocarCpfInput()"
                placeholder="Buscar por CPF ou nome..."
                class="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm outline-none focus:ring-2 pr-9"
                style="focus:ring-color: var(--brand-primary)" />
              <div *ngIf="isLoadingTrocar"
                class="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin rounded-full border-2 border-gray-300"
                style="border-top-color: var(--brand-primary)"></div>
            </div>

            <!-- Resultados da busca -->
            <div *ngIf="trocarResultados.length > 0"
              class="border border-gray-200 rounded-xl overflow-hidden max-h-48 overflow-y-auto">
              <button *ngFor="let r of trocarResultados" (click)="selecionarTrocar(r)"
                class="w-full text-left px-4 py-2.5 text-sm border-b border-gray-100 last:border-0 transition-colors hover:bg-purple-50">
                <p class="font-medium text-gray-800">{{ r.nmPessoaFisica | titlecase }}</p>
                <p class="text-xs text-gray-400">{{ r.nrCpf }}</p>
              </button>
            </div>

            <!-- Sem resultado: cadastrar -->
            <div *ngIf="!isLoadingTrocar && !trocarPacienteSelecionado && trocarCpfQuery.trim().length >= 3 && trocarResultados.length === 0"
              class="flex items-center justify-between gap-2 rounded-xl px-4 py-3" style="background-color: var(--brand-surface)">
              <span class="text-xs" style="color: var(--tx-2)">Nenhum paciente encontrado.</span>
              <button type="button" (click)="abrirCadastroPaciente('trocar', trocarCpfQuery)"
                class="px-3 py-1.5 rounded-lg text-white text-xs font-semibold" style="background-color: var(--brand-secondary)">
                Cadastrar paciente
              </button>
            </div>

            <!-- Paciente selecionado -->
            <div *ngIf="trocarPacienteSelecionado" class="flex items-center gap-3 rounded-xl px-4 py-3 border"
              style="background-color: var(--brand-surface); border-color: var(--flua-borda)">
              <div class="flex-1 min-w-0">
                <p class="font-semibold text-sm truncate" style="color: var(--tx)">
                  {{ trocarPacienteSelecionado.nmPessoaFisica | titlecase }}
                </p>
                <p class="text-xs mt-0.5" style="color: var(--tx-2)">{{ trocarPacienteSelecionado.nrCpf }}</p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                class="size-5 text-green-500 shrink-0">
                <path fill-rule="evenodd"
                  d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                  clip-rule="evenodd" />
              </svg>
            </div>

            <!-- Erro -->
            <p *ngIf="trocarErro" class="text-xs text-red-600 text-center">{{ trocarErro }}</p>
          </div>

          <!-- Footer -->
          <div class="px-5 py-4 border-t border-gray-100 flex gap-2">
            <button (click)="fecharTrocarPaciente()"
              class="flex-1 py-2.5 rounded-xl text-sm font-medium border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors">
              Cancelar
            </button>
            <button (click)="confirmarTrocarPaciente()" [disabled]="!trocarPacienteSelecionado || isLoadingTrocar"
              class="flex-1 py-2.5 rounded-xl text-sm font-medium text-white transition-colors disabled:opacity-50"
              style="background-color: var(--brand-primary)">
              <span *ngIf="!isLoadingTrocar">Confirmar Troca</span>
              <span *ngIf="isLoadingTrocar">Trocando...</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Agendamentos -->
      <div class="rounded-2xl overflow-hidden shadow-sm" style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
        <div class="px-5 py-3 flex items-center justify-between" style="border-bottom: 1px solid var(--flua-borda)">
          <p class="font-semibold text-sm" style="color: var(--tx)">Agendamentos de Hoje</p>
          <button (click)="carregarAgendas()" title="Recarregar" class="p-1 rounded" style="color: var(--brand-primary)"
            onmouseover="this.style.backgroundColor='var(--brand-tint)'" onmouseout="this.style.backgroundColor='transparent'">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
          </button>
        </div>

        <div *ngIf="isLoadingAgendas" class="flex justify-center py-8">
          <div class="h-7 w-7 animate-spin rounded-full border-4 border-gray-300"
            style="border-top-color: var(--brand-primary)"></div>
        </div>

        <div *ngIf="!isLoadingAgendas && agendas.length === 0 && !parceiraSelecionada" class="flex flex-col items-center text-center py-8 px-4 gap-1">
          <span class="grid place-items-center rounded-full mb-2"
                style="width: 40px; height: 40px; background: var(--brand-tint); color: var(--brand-primary)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8"
              stroke="currentColor" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
            </svg>
          </span>
          <p style="font-size: 14px; font-weight: 700; color: var(--tx-2)">Nenhum agendamento para hoje</p>
          <p style="font-size: 12px; color: var(--tx-2); max-width: 360px">
            {{ isOdonto ? 'Este paciente não tem consulta odontológica marcada hoje nesta unidade.' : 'Este paciente não tem consulta marcada hoje nesta unidade.' }}
            Para atendê-lo agora, use <strong style="color: var(--brand-primary)">Agendamento Rápido</strong> abaixo<ng-container *ngIf="clinicasParceiras.length"> ou <strong style="color: var(--brand-primary)">Atendimento em clínica parceira</strong></ng-container>.
          </p>
        </div>

        <!-- Clínica parceira escolhida (sem agendamento) -->
        <div *ngIf="!isLoadingAgendas && parceiraSelecionada" class="px-5 py-3 flex items-center gap-4"
          style="background-color: var(--brand-tint)">
          <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0"
            style="border-color: var(--brand-primary)">
            <div class="w-2.5 h-2.5 rounded-full" style="background-color: var(--brand-primary)"></div>
          </div>
          <div class="flex-1 text-sm min-w-0">
            <div class="flex items-center gap-2 flex-wrap">
              <p class="font-semibold" style="color: var(--tx)">{{ selectedAgenda.doctorName }}</p>
              <span class="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-blue-100 text-blue-700">Exame</span>
            </div>
            <p class="text-xs mt-0.5" style="color: var(--tx-2)">Clínica parceira · sem agendamento</p>
          </div>
          <button type="button" (click)="abrirParceirasModal()" class="text-xs font-semibold px-2 py-1 rounded"
            style="color: var(--brand-primary)">Trocar</button>
        </div>

        <!-- Botão Agendamento Rápido (modal do "encaixe") -->
        <div *ngIf="!isLoadingAgendas" class="px-5 py-3 grid gap-2" [ngClass]="{ 'sm:grid-cols-2': clinicasParceiras.length > 0 }"
          style="border-top: 1px solid var(--flua-borda)">
          <button (click)="abrirModalEncaixe()"
            class="w-full flex items-center justify-center gap-2 rounded-lg py-2 text-sm font-medium transition-colors"
            style="border: 1.5px dashed var(--brand-primary); color: var(--brand-primary); background-color: transparent"
            onmouseover="this.style.backgroundColor='var(--brand-tint)'" onmouseout="this.style.backgroundColor='transparent'">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
            Agendamento Rápido
          </button>
          <button *ngIf="clinicasParceiras.length" (click)="abrirParceirasModal()"
            class="w-full flex items-center justify-center gap-2 rounded-lg py-2 text-sm font-medium transition-colors"
            style="border: 1.5px dashed var(--brand-primary); color: var(--brand-primary); background-color: transparent"
            onmouseover="this.style.backgroundColor='var(--brand-tint)'" onmouseout="this.style.backgroundColor='transparent'">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21" />
            </svg>
            Atendimento em clínica parceira
          </button>
        </div>

        <div *ngIf="!isLoadingAgendas && agendas.length > 0" class="divide-y" style="border-color: var(--flua-borda)">
          <div *ngFor="let agenda of agendas" (click)="agenda.nrAtendimento ? null : selectAgenda(agenda)"
            class="px-5 py-3 flex items-center gap-4 transition-colors" [class.cursor-pointer]="!agenda.nrAtendimento"
            [class.cursor-not-allowed]="agenda.nrAtendimento"
            [style.background-color]="agenda.nrAtendimento ? '#F4F1EA' : isSelected(agenda) ? 'var(--brand-tint)' : 'white'"
            [style.opacity]="agenda.nrAtendimento ? '0.6' : '1'">
            <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0"
              [style.border-color]="agenda.nrAtendimento ? '#9AA6AF' : isSelected(agenda) ? 'var(--brand-primary)' : '#9AA6AF'">
              <div *ngIf="isSelected(agenda) && !agenda.nrAtendimento" class="w-2.5 h-2.5 rounded-full"
                style="background-color: var(--brand-primary)"></div>
            </div>
            <div class="flex items-center gap-3 flex-shrink-0"
              [style.background-color]="agenda.nrAtendimento ? '#9AA6AF' : 'var(--brand-primary)'"
              style="border-radius: 6px; padding: 4px 10px">
              <span class="text-white text-sm font-bold">{{ formatTime(agenda.appointmentDate) }}</span>
            </div>
            <div class="flex-1 text-sm">
              <div class="flex items-center gap-2 flex-wrap">
                <p class="font-semibold" style="color: var(--tx)">{{ agenda.doctorName }}</p>
                <span *ngIf="agenda.classification === 'CONSULTATION' && agenda.scheduleClassification !== 'R'"
                  class="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-purple-100 text-purple-700">Consulta</span>
                <span *ngIf="agenda.classification === 'CONSULTATION' && agenda.scheduleClassification === 'R'"
                  class="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-orange-100 text-orange-700">Retorno</span>
                <span *ngIf="agenda.classification === 'EXAM'"
                  class="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-blue-100 text-blue-700">Exame</span>
                <span *ngIf="unidadeDeOutraAgenda(agenda) as outra" class="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-amber-100 text-amber-800">Agendado em {{ outra }}</span>
                <span *ngIf="agenda.nrAtendimento" class="px-2 py-0.5 rounded-full text-[10px] font-semibold"
                  style="background-color: #fee2e2; color: #991b1b">Atend. #{{ agenda.nrAtendimento }} já aberto</span>
              </div>
              <p class="text-xs mt-0.5" style="color: var(--tx-2)">{{ agenda.specialtyName }}<span *ngIf="agenda.isParceiro"> · parceiro: {{ agenda.nmClinicaParceira }}</span></p>
            </div>
          </div>
        </div>
      </div>

      <!-- Tipo e Convênio -->
      <div class="rounded-2xl overflow-hidden shadow-sm" style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
        <div class="px-5 py-3" style="border-bottom: 1px solid var(--flua-borda)">
          <p class="font-semibold text-sm" style="color: var(--tx)">Tipo e Convênio</p>
        </div>
        <div class="px-5 py-4 grid grid-cols-1 sm:grid-cols-3 gap-4">

          <!-- Tipo de Atendimento -->
          <div class="flex flex-col gap-1">
            <label class="text-xs font-medium" style="color: var(--tx-2)">
              Tipo de Atendimento <span style="color: #d34747">*</span>
            </label>
            <select [(ngModel)]="tipoAtendimento" class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
              style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)">
              <option [ngValue]="8">Atendimento Ambulatorial</option>
              <option [ngValue]="8">Retorno</option>
            </select>
          </div>

          <!-- Convênio -->
          <div class="flex flex-col gap-1">
            <label class="text-xs font-medium" style="color: var(--tx-2)">Convênio</label>
            <select *ngIf="selectedAgenda" [(ngModel)]="selectedCdConvenio" (ngModelChange)="onConvenioChange()"
              class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
              style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)">
              <option [ngValue]="null">Selecione</option>
              <option *ngFor="let c of convenios" [ngValue]="c.cdConvenio">{{ convenioLabel(c.dsConvenio) }}</option>
            </select>
            <input *ngIf="!selectedAgenda" type="text" disabled
              [value]="convenioLabel(selectedPassword?.planDescription) || '—'"
              class="w-full rounded-lg border px-3 py-2 text-sm"
              style="border-color: var(--flua-borda); color: var(--tx-2); background-color: var(--flua-fundo)" />
          </div>

          <!-- Categoria -->
          <div class="flex flex-col gap-1">
            <label class="text-xs font-medium" style="color: var(--tx-2)">Categoria</label>
            <select *ngIf="selectedAgenda" [(ngModel)]="selectedCdCategoria"
              class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
              style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)">
              <option [ngValue]="null">Selecione</option>
              <option *ngFor="let cat of categorias" [ngValue]="cat.cdCategoria">{{ cat.dsCategoria }}</option>
            </select>
            <input *ngIf="!selectedAgenda" type="text" disabled [value]="selectedPassword?.planModality || '—'"
              class="w-full rounded-lg border px-3 py-2 text-sm"
              style="border-color: var(--flua-borda); color: var(--tx-2); background-color: var(--flua-fundo)" />
          </div>
        </div>
      </div>

      <!-- Informações Adicionais -->
      <div class="rounded-2xl overflow-hidden shadow-sm" style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
        <div class="px-5 py-3" style="border-bottom: 1px solid var(--flua-borda)">
          <p class="font-semibold text-sm" style="color: var(--tx)">Informações Adicionais</p>
        </div>
        <div class="px-5 py-4 grid grid-cols-1 sm:grid-cols-2 gap-4">

          <!-- Classificação -->
          <div class="flex flex-col gap-1">
            <label class="text-xs font-medium" style="color: var(--tx-2)">
              Classificação <span style="color: #d34747">*</span>
            </label>
            <select [(ngModel)]="classificacao" [disabled]="parceiraSelecionada"
              class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
              style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)">
              <option value="C">Consulta</option>
              <option value="R">Retorno</option>
              <option *ngIf="parceiraSelecionada" value="E">Exames</option>
            </select>
          </div>

          <!-- Setor de Atendimento -->
          <div class="flex flex-col gap-1">
            <label class="text-xs font-medium" style="color: var(--tx-2)">
              Setor de Atendimento <span style="color: #d34747">*</span>
            </label>
            <div *ngIf="isLoadingSetores" class="flex items-center gap-2 text-sm" style="color: var(--tx-2)">
              <div class="h-4 w-4 animate-spin rounded-full border-2 border-gray-300"
                style="border-top-color: var(--brand-primary)"></div>
              Carregando setores...
            </div>
            <select *ngIf="!isLoadingSetores" [(ngModel)]="cdSetorAtendimento"
              class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
              style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)">
              <option [ngValue]="null">Selecione...</option>
              <option *ngFor="let setor of setores" [ngValue]="setor.cdSetorAtendimento">
                {{ setor.dsSetorAtendimento }}
              </option>
            </select>
            <p *ngIf="!isLoadingSetores && setores.length === 0" class="text-xs" style="color: #d34747">
              Nenhum setor encontrado. Verifique o GRANT SELECT ON TASY.SETOR_ATENDIMENTO.
            </p>
          </div>
        </div>
      </div>

      <!-- Botões Step 1 -->
      <div class="flex justify-between">
        <button (click)="voltarStep('validacao')" class="px-4 py-2 rounded-lg border text-sm font-medium"
          style="border-color: var(--flua-borda); color: var(--tx-2)" onmouseover="this.style.backgroundColor='var(--brand-surface)'"
          onmouseout="this.style.backgroundColor='transparent'">
          ← Voltar
        </button>
        <button (click)="avancarStep2()" class="px-6 py-2 rounded-lg text-white text-sm font-semibold"
          style="background-color: var(--brand-primary)" onmouseover="this.style.backgroundColor='var(--brand-ink)'"
          onmouseout="this.style.backgroundColor='var(--brand-primary)'">
          Próximo →
        </button>
      </div>
    </div>

    <!-- ════════════════════════════════════════════════════════════
         STEP 2 — PROCEDIMENTOS
         ════════════════════════════════════════════════════════════ -->
    <div *ngIf="stage === 'step2'" class="flex flex-col gap-4">

      <div class="rounded-2xl shadow" style="background-color: var(--brand-surface)">
        <div class="px-5 py-3 flex items-center gap-2"
          style="border-bottom: 1px solid var(--flua-borda); border-radius: 16px 16px 0 0">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="var(--brand-primary)" class="size-4 shrink-0">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
          </svg>
          <p class="font-semibold text-sm" style="color: var(--tx)">Prescrição e Procedimentos</p>
        </div>

        <div class="px-5 py-4 flex flex-col gap-4">

          <!-- Médico Responsável e busca empilhados em largura total -->
          <div class="flex flex-col gap-4">

            <!-- Médico Responsável (readonly) -->
            <div class="flex flex-col gap-1">
              <label class="text-xs font-medium" style="color: var(--tx-2)">Médico Responsável *</label>
              <input type="text" disabled [value]="selectedAgenda?.doctorName || '—'"
                class="w-full rounded-lg border px-3 py-2 text-sm"
                style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--flua-fundo)" />
            </div>

            <!-- Buscar Procedimento + Ver tabela + Orçamento (linha inteira) -->
            <div class="flex flex-col gap-1">
              <div class="flex items-center justify-between flex-wrap gap-1">
                <label class="text-xs font-medium whitespace-nowrap" style="color: var(--tx-2)">Buscar Procedimento</label>
                <!-- Filtro por tipo -->
                <div class="flex gap-1 flex-wrap">
                  <button *ngFor="let f of [
                      { k: 'todos', l: 'Todos' }, { k: 'consulta', l: 'Consultas' },
                      { k: 'exame', l: 'Exames' }, { k: 'odonto', l: 'Odonto' }]"
                    type="button" (click)="setFiltroTipoBusca($any(f.k))"
                    class="px-2.5 py-1 rounded-full text-xs font-medium"
                    [ngStyle]="filtroTipoBusca === f.k
                      ? { 'background-color': 'var(--brand-primary)', color: 'white' }
                      : { 'background-color': '#F4F1EA', color: '#4A5D6B' }">
                    {{ f.l }}
                  </button>
                </div>
              </div>
              <div class="flex gap-2 items-start flex-wrap">

                <!-- Typeahead -->
                <div class="flex-1 procedimento-search-container" style="position: relative; min-width: 220px">
                  <input type="text" [(ngModel)]="procedimentosBusca" (ngModelChange)="filtrarProcedimentos()"
                    (focus)="filtrarProcedimentos()" placeholder="Digite para buscar..."
                    class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
                    style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />

                  <div *ngIf="isLoadingProcedimentos" class="absolute right-3 top-2.5">
                    <div class="h-4 w-4 animate-spin rounded-full border-2 border-gray-300"
                      style="border-top-color: var(--brand-primary)"></div>
                  </div>

                  <div *ngIf="showDropdownProcedimentos && procedimentosFiltrados.length > 0"
                    class="absolute z-20 rounded-lg shadow-lg mt-1 overflow-y-auto"
                    style="background-color: var(--cartao); border: 1px solid var(--flua-borda); top: 100%; max-height: 300px;
                           width: max(100%, 380px); max-width: min(90vw, 560px); left: 0">
                    <div *ngFor="let proc of procedimentosFiltrados" (click)="adicionarProcedimento(proc)"
                      class="px-4 py-2.5 cursor-pointer text-sm flex items-center justify-between gap-3"
                      style="border-bottom: 1px solid #F4F1EA"
                      onmouseover="this.style.backgroundColor='var(--brand-surface)'"
                      onmouseout="this.style.backgroundColor='white'">
                      <div class="min-w-0">
                        <p class="font-medium truncate" style="color: var(--tx)">{{ proc.dsProcExame }}</p>
                        <p class="text-xs mt-0.5" style="color: var(--tx-2)">
                          Código: {{ proc.cdProcedimento }}
                          <span *ngIf="proc.dsClassificacao"> · {{ proc.dsClassificacao }}</span>
                        </p>
                      </div>
                      <span class="text-xs font-semibold whitespace-nowrap px-2 py-0.5 rounded"
                        [ngStyle]="proc.vlProcedimento != null
                          ? { 'background-color': '#e7f6ef', color: '#1d7a55' }
                          : { 'background-color': '#F4F1EA', color: '#8796A1' }">
                        {{ formatarPrecoProc(proc) }}
                      </span>
                    </div>
                    <!-- Indicador de total de resultados -->
                    <div class="px-4 py-2 text-center text-xs sticky bottom-0"
                      style="background-color: var(--brand-surface); color: var(--tx-2); border-top: 1px solid var(--flua-borda)">
                      {{ procedimentosFiltrados.length }} resultado(s) encontrado(s)
                    </div>
                  </div>
                </div>

                <!-- Botão Ver tabela -->
                <div style="flex-shrink: 0">
                  <button type="button" (click)="abrirTabelaProcedimentos()"
                    class="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium border"
                    style="border-color: var(--flua-borda); color: var(--tx-2); background-color: var(--cartao); white-space: nowrap"
                    onmouseover="this.style.backgroundColor='var(--brand-surface)'"
                    onmouseout="this.style.backgroundColor='white'">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                      stroke="currentColor" class="size-4">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M3.75 6h16.5M3.75 12h16.5m-16.5 6h16.5" />
                    </svg>
                    Ver tabela
                  </button>
                </div>

                <!-- Botão Orçamento -->
                <div style="flex-shrink: 0">
                  <button (click)="abrirOrcamento()" [disabled]="isLoadingOrcamentos"
                    class="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium"
                    style="background-color: var(--thead); color: white; white-space: nowrap"
                    onmouseover="this.style.backgroundColor='#0B2C45'"
                    onmouseout="this.style.backgroundColor='var(--brand-accent)'">
                    <div *ngIf="isLoadingOrcamentos"
                      class="h-3.5 w-3.5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                    <svg *ngIf="!isLoadingOrcamentos" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                      stroke-width="1.5" stroke="currentColor" class="size-4">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>
                    Orçamento
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Spinner carregando procedimento padrão -->
          <div *ngIf="isLoadingPadrao" class="flex items-center gap-2 text-sm py-2" style="color: var(--tx-2)">
            <div class="h-4 w-4 animate-spin rounded-full border-2 border-gray-300"
              style="border-top-color: var(--brand-primary)"></div>
            Carregando procedimento padrão...
          </div>

          <!-- Lista de procedimentos -->
          <div class="rounded-xl" style="border: 1px solid var(--flua-borda); min-height: 120px; overflow: visible">

            <!-- Estado vazio -->
            <div *ngIf="procedimentosAdicionados.length === 0 && !isLoadingPadrao"
              class="flex flex-col items-center justify-center py-10 gap-2" style="color: var(--tx-2)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-9 opacity-30">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
              </svg>
              <p class="text-sm font-medium">Nenhum procedimento adicionado</p>
              <p class="text-xs">Use o campo acima para buscar e adicionar procedimentos</p>
            </div>

            <!-- Itens -->
            <div *ngFor="let proc of procedimentosAdicionados; let i = index; let last = last" class="px-4 py-3"
              [style.border-bottom]="!last ? '1px solid #F4F1EA' : 'none'" style="background-color: var(--cartao)">
              <div class="flex items-start gap-3">

                <!-- Nome + código -->
                <div class="flex-1 min-w-0">
                  <p class="font-semibold text-sm" style="color: var(--tx)">{{ proc.nome }}</p>
                  <p class="text-xs mt-0.5" style="color: var(--tx-2)">Código: {{ proc.cdProcedimento }}</p>
                </div>

                <!-- Médico Executor typeahead -->
                <div class="flex flex-col gap-0.5 medico-search-container"
                  style="position: relative; width: 180px; flex-shrink: 0">
                  <span class="text-xs" style="color: var(--tx-2)">Médico Executor:</span>

                  <!-- Médico já selecionado -->
                  <div *ngIf="proc.nomeMedicoExecutor" class="flex items-center gap-1 rounded border px-2 py-1 text-xs"
                    style="border-color: var(--brand-primary); background-color: var(--brand-tint); color: var(--brand-ink)">
                    <span class="flex-1 truncate">{{ proc.nomeMedicoExecutor }}</span>
                    <button (click)="limparMedico(i)" style="color: var(--brand-primary); flex-shrink: 0">✕</button>
                  </div>

                  <!-- Campo busca (quando não selecionado) -->
                  <div *ngIf="!proc.nomeMedicoExecutor">
                    <input type="text" [(ngModel)]="proc.medicoBusca" (ngModelChange)="filtrarMedicos(i)"
                      (focus)="filtrarMedicos(i)" placeholder="Buscar médico..."
                      class="w-full rounded border px-2 py-1 text-xs outline-none"
                      style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
                    <p class="text-xs mt-0.5" style="color: var(--tx-2); font-style: italic">Padrão: Médico principal</p>
                  </div>

                  <!-- Dropdown médicos -->
                  <div *ngIf="proc.showMedicoDropdown && proc.medicosFiltrados.length > 0"
                    class="absolute z-30 rounded-lg shadow-lg"
                    [style]="'background-color: var(--cartao); border: 1px solid var(--flua-borda); left: 0; right: 0; max-height: 200px; overflow-y: auto;' + (last ? 'bottom: 100%; margin-bottom: 2px' : 'top: 100%; margin-top: 2px')">
                    <div *ngFor="let medico of proc.medicosFiltrados" (click)="selecionarMedico(i, medico)"
                      class="px-3 py-2 cursor-pointer text-xs" style="border-bottom: 1px solid #F4F1EA"
                      onmouseover="this.style.backgroundColor='var(--brand-surface)'"
                      onmouseout="this.style.backgroundColor='white'">
                      <p style="color: var(--tx)">{{ medico.doctorName }}</p>
                      <p *ngIf="medico.isParceiro" class="text-[10px]" style="color: var(--tx-2)">parceiro</p>
                    </div>
                  </div>
                </div>

                <!-- Qtd -->
                <div class="flex flex-col gap-0.5" style="flex-shrink: 0">
                  <span class="text-xs" style="color: var(--tx-2)">Qtd:</span>
                  <input type="number" [(ngModel)]="proc.quantidade" min="1"
                    class="rounded border px-2 py-1 text-xs outline-none text-center"
                    style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao); width: 56px" />
                </div>

                <!-- Remover -->
                <button (click)="removerProcedimento(i)" class="p-1.5 rounded-lg flex-shrink-0 mt-3"
                  style="background-color: #fde8e8; color: #d34747" onmouseover="this.style.backgroundColor='#f8c8c8'"
                  onmouseout="this.style.backgroundColor='#fde8e8'">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="size-4">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botões Step 2 -->
      <div class="flex justify-between">
        <button (click)="voltarStep('step1')" class="px-4 py-2 rounded-lg border text-sm font-medium"
          style="border-color: var(--flua-borda); color: var(--tx-2)" onmouseover="this.style.backgroundColor='var(--brand-surface)'"
          onmouseout="this.style.backgroundColor='transparent'">
          ← Voltar
        </button>
        <button (click)="avancarStep3()" class="px-6 py-2 rounded-lg text-white text-sm font-semibold"
          style="background-color: var(--brand-primary)" onmouseover="this.style.backgroundColor='var(--brand-ink)'"
          onmouseout="this.style.backgroundColor='var(--brand-primary)'">
          Avançar →
        </button>
      </div>
    </div>

    <!-- ════════════════════════════════════════════════════════════
         STEP 3 — CONFIRMAÇÃO
         ════════════════════════════════════════════════════════════ -->
    <div *ngIf="stage === 'step3'" class="flex flex-col gap-4">

      <div *ngIf="verificandoCartaoSim" class="verificando-cartaosim" role="status" aria-live="polite">
        <span class="verificando-ponto"></span>
        <span>Verificando CartãoSiM…</span>
      </div>

      <!-- Pendência CartãoSiM: cliente bloqueado/em atraso vê a fatura unificada em vez da oferta -->
      <app-pendencia-sim [personId]="selectedPassword?.personId ?? 0" [clinicId]="clinicId" [cpf]="cpfDoPaciente" [guiche]="guicheAtual"
                         [procedimentos]="procedimentosDaOferta" (valorParticular)="valorParticularVisita = $event"
                         (temPendencia)="temPendenciaSim = $event" (regularizado)="onRegularizado()"></app-pendencia-sim>

      <!-- Assinatura cancelada com fatura em aberto: só informa (ticket no GLPI) e a adesão some -->
      <app-pendencia-cancelada-sim *ngIf="!temPendenciaSim" [personId]="selectedPassword?.personId ?? 0"
                                   [clinicId]="clinicId" [cpf]="cpfDoPaciente" [guiche]="guicheAtual" [procedimentos]="procedimentosDaOferta"
                                   (temPendencia)="temCanceladaSim = $event"></app-pendencia-cancelada-sim>

      <!-- Multa ou anuidade antiga de cancelada: a Fila não cobra, mas o CartãoSiM recusa a adesão -->
      <app-bloqueio-adesao-sim *ngIf="!temPendenciaSim && !temCanceladaSim" [personId]="selectedPassword?.personId ?? 0"
                               (temBloqueio)="temBloqueioSim = $event"></app-bloqueio-adesao-sim>

      <!-- Oferta SiM+ (handoff v3) -->
      <app-oferta-sim *ngIf="!temPendenciaSim && !temCanceladaSim && temBloqueioSim === false" [clinicId]="clinicId" [personId]="selectedPassword?.personId ?? 0" [cpf]="cpfDoPaciente"
                      [convenioParticular]="convenioParticular" [procedimentos]="procedimentosDaOferta" [guiche]="guicheAtual" [senhaId]="selectedPassword?.id ?? 0"
                      (valorParticular)="valorParticularVisita = $event" (ativada)="onAssinaturaAtivada($event)"></app-oferta-sim>

      <!-- Melhorar plano: assinante ativo; a oferta de adesão some sozinha para ele (ja-e-assinante) -->
      <app-melhorar-plano-sim *ngIf="!temPendenciaSim" [clinicId]="clinicId" [personId]="selectedPassword?.personId ?? 0"
                              [cpf]="cpfDoPaciente" [guiche]="guicheAtual"
                              (migrado)="onAssinaturaAtivada($event)"></app-melhorar-plano-sim>

      <div class="rounded-2xl overflow-hidden shadow-sm" style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
        <div class="px-5 py-4 flex flex-col gap-5 text-sm">

          <!-- Paciente (handoff v3, secao 8): a tag muda quando ele vira assinante -->
          <div class="flex items-center justify-between gap-3 flex-wrap">
            <div class="flex items-center gap-2 flex-wrap min-w-0">
              <span class="font-bold" style="font-size: 15px; color: var(--tx)">{{ selectedPassword?.name | titlecase }}</span>
              <span class="text-xs" style="color: var(--brand-muted)">Cód. {{ selectedPassword?.personId }}</span>
              <span *ngIf="!assinaturaAtivada" class="rounded-full px-2 py-0.5 text-xs font-bold"
                    style="background-color: var(--brand-tint); color: var(--brand-text-soft)">{{ convenioParticular ? 'Particular' : 'Convênio' }}</span>
              <span *ngIf="assinaturaAtivada && corDoAssinante" class="rounded-full px-2 py-0.5 text-xs font-bold"
                    [style.background-color]="corDoAssinante.fundo" [style.color]="corDoAssinante.texto">
                Assinante {{ assinaturaAtivada.familia.nome }}
              </span>
            </div>
            <span class="text-xs font-semibold" style="color: #0E7A53">● Pronto para criar</span>
          </div>

          <hr style="border-color: var(--flua-borda)" />

          <!-- Agendamento -->
          <div>
            <p class="text-xs font-semibold uppercase mb-2" style="color: var(--brand-primary); letter-spacing: .05em">
              Agendamento
            </p>
            <div class="grid grid-cols-2 gap-x-6 gap-y-2">
              <div>
                <span style="color: var(--tx-2)">Data/Hora</span>
                <p class="font-semibold" style="color: var(--tx)">
                  <ng-container *ngIf="!parceiraSelecionada; else semAgendamentoParceira">
                    {{ formatDate(selectedAgenda?.appointmentDate) }} {{ formatTime(selectedAgenda?.appointmentDate) }}
                  </ng-container>
                  <ng-template #semAgendamentoParceira>Sem agendamento (clínica parceira)</ng-template>
                </p>
              </div>
              <div>
                <span style="color: var(--tx-2)">Médico</span>
                <p class="font-semibold" style="color: var(--tx)">{{ selectedAgenda?.doctorName }}</p>
              </div>
              <div>
                <span style="color: var(--tx-2)">Tipo</span>
                <p class="font-semibold" style="color: var(--tx)">{{ tipoAtendimentoLabel }}</p>
              </div>
              <div>
                <span style="color: var(--tx-2)">Classificação</span>
                <p class="font-semibold" style="color: var(--tx)">{{ classificacaoLabel }}</p>
              </div>
              <div>
                <span style="color: var(--tx-2)">Setor</span>
                <p class="font-semibold" style="color: var(--tx)">{{ dsSetorSelecionado }}</p>
              </div>
              <div>
                <span style="color: var(--tx-2)">Convênio</span>
                <p class="font-semibold" style="color: var(--tx)">{{ convenioResumo }}</p>
              </div>
            </div>
          </div>

          <hr style="border-color: var(--flua-borda)" />

          <!-- Procedimentos -->
          <div>
            <p class="text-xs font-semibold uppercase mb-2" style="color: var(--brand-primary); letter-spacing: .05em">
              Procedimentos ({{ procedimentosAdicionados.length }})
            </p>

            <!-- Sem procedimentos extras -->
            <div *ngIf="procedimentosAdicionados.length === 0" class="text-xs py-2" style="color: var(--tx-2)">
              Nenhum procedimento extra adicionado — o sistema utilizará o procedimento padrão da especialidade.
            </div>

            <!-- Lista de procedimentos -->
            <div *ngFor="let proc of procedimentosAdicionados; let i = index" class="rounded-xl px-4 py-3 mb-2"
              style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
              <p class="font-semibold" style="color: var(--tx)">{{ proc.nome }}</p>
              <p class="text-xs mt-0.5" style="color: var(--tx-2)">
                Código: {{ proc.cdProcedimento }} &nbsp;|&nbsp; Qtd: {{ proc.quantidade }}
                <span *ngIf="proc.nomeMedicoExecutor"> &nbsp;|&nbsp; Executor: {{ proc.nomeMedicoExecutor }}</span>
              </p>
            </div>
          </div>

          <!-- Assinou agora: particular riscado e o valor com o plano -->
          <div *ngIf="assinaturaAtivada?.comPlano != null" class="flex items-baseline justify-end gap-2"
               style="border-top: 1px solid var(--flua-borda); padding-top: 12px">
            <span class="text-xs" style="color: var(--tx-2)">Valor</span>
            <s *ngIf="valorParticularVisita !== null" class="text-xs" style="color: var(--brand-muted)">{{ valorParticularVisita | brl }}</s>
            <span class="font-bold" style="color: #0E7A53">{{ assinaturaAtivada!.comPlano | brl }}</span>
          </div>

          <!-- Valor no convênio que a conta vai ter -->
          <div *ngIf="assinaturaAtivada?.comPlano == null && (valorVisita || isCalculandoValor)"
               class="flex flex-col items-end gap-0.5" style="border-top: 1px solid var(--flua-borda); padding-top: 12px">
            <div class="flex items-baseline gap-2">
              <span class="text-xs" style="color: var(--tx-2)">Valor</span>
              <span *ngIf="isCalculandoValor" class="text-xs" style="color: var(--tx-2)">calculando...</span>
              <span *ngIf="!isCalculandoValor && valorVisita" class="font-bold" style="color: var(--tx)">{{ valorVisita.valor | brl }}</span>
            </div>
            <span *ngIf="valorVisita?.semPreco?.length" class="text-xs" style="color: #8A5A0C">
              {{ valorVisita!.semPreco.length }} procedimento(s) sem preço neste convênio, fora do total
            </span>
          </div>

        </div>
      </div>

      <!-- Botões Step 3 -->
      <div class="flex justify-between">
        <button (click)="voltarStep('step2')" class="px-4 py-2 rounded-lg border text-sm font-medium"
          style="border-color: var(--flua-borda); color: var(--tx-2)" onmouseover="this.style.backgroundColor='var(--brand-surface)'"
          onmouseout="this.style.backgroundColor='transparent'">
          ← Voltar
        </button>
        <button (click)="criarAtendimento()" [disabled]="isSubmitting || isVerificandoDuplicado"
          class="px-6 py-2 rounded-lg text-white text-sm font-semibold flex items-center gap-2"
          [style.backgroundColor]="(isSubmitting || isVerificandoDuplicado) ? '#D6CFC2' : 'var(--brand-primary)'"
          [style.cursor]="(isSubmitting || isVerificandoDuplicado) ? 'not-allowed' : 'pointer'"
          onmouseover="if(!this.disabled) this.style.backgroundColor='var(--brand-ink)'"
          onmouseout="if(!this.disabled) this.style.backgroundColor='var(--brand-primary)'">
          <div *ngIf="isVerificandoDuplicado || isSubmitting"
            class="h-4 w-4 animate-spin rounded-full border-2 border-white" style="border-top-color: transparent"></div>
          <svg *ngIf="!isVerificandoDuplicado && !isSubmitting" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
          </svg>
          {{ isVerificandoDuplicado ? 'Verificando...' : (isSubmitting ? 'Criando...' : 'Criar Atendimento') }}
        </button>
      </div>
    </div>

    <!-- ════════════════════════════════════════════════════════════
         PAGAMENTO
         ════════════════════════════════════════════════════════════ -->
    <div *ngIf="stage === 'pagamento'" class="space-y-4">

      <!-- Banner de sucesso — Atendimento criado -->
      <div class="rounded-2xl px-5 py-4 flex items-center gap-3" style="background-color: var(--thead)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="white"
          class="size-7 shrink-0">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
        <div class="flex-1">
          <p class="font-semibold text-white text-sm">Atendimento Criado com Sucesso!</p>
          <div class="flex gap-4 mt-1 text-xs text-white/90">
            <span class="cursor-pointer hover:underline" (click)="copiarValor('atendimento', resultado?.nrAtendimento)"
              [title]="copiadoCampo === 'atendimento' ? 'Copiado!' : 'Clique para copiar'">
              Atendimento: <strong class="text-white">#{{ resultado?.nrAtendimento }}</strong>
              <svg *ngIf="copiadoCampo !== 'atendimento'" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-3 inline ml-0.5 -mt-0.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9.75a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184" />
              </svg>
              <svg *ngIf="copiadoCampo === 'atendimento'" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-3 inline ml-0.5 -mt-0.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>
            </span>
            <span class="cursor-pointer hover:underline" (click)="copiarValor('prescricao', resultado?.nrPrescricao)"
              [title]="copiadoCampo === 'prescricao' ? 'Copiado!' : 'Clique para copiar'">
              Prescrição: <strong class="text-white">#{{ resultado?.nrPrescricao }}</strong>
              <svg *ngIf="copiadoCampo !== 'prescricao'" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-3 inline ml-0.5 -mt-0.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9.75a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184" />
              </svg>
              <svg *ngIf="copiadoCampo === 'prescricao'" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-3 inline ml-0.5 -mt-0.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>
            </span>
            <span *ngIf="dadosPagamento" class="cursor-pointer hover:underline"
              (click)="copiarValor('conta', dadosPagamento.nrInternoConta)"
              [title]="copiadoCampo === 'conta' ? 'Copiado!' : 'Clique para copiar'">
              Conta Interna: <strong class="text-white">#{{ dadosPagamento.nrInternoConta }}</strong>
              <svg *ngIf="copiadoCampo !== 'conta'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="2" stroke="currentColor" class="size-3 inline ml-0.5 -mt-0.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9.75a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184" />
              </svg>
              <svg *ngIf="copiadoCampo === 'conta'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="2" stroke="currentColor" class="size-3 inline ml-0.5 -mt-0.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>
            </span>
            <span *ngIf="dadosPagamento?.dsConvenio as dsConvenio">
              Convênio: <strong class="text-white">{{ convenioLabel(dsConvenio) }}</strong>
            </span>
            <span *ngIf="dadosPagamento?.dsCategoria as dsCategoria">
              Categoria: <strong class="text-white">{{ dsCategoria }}</strong>
            </span>
          </div>
          <!-- Status da Agenda -->
          <div *ngIf="selectedAgenda?.id" class="flex items-center gap-2 mt-1.5">
            <span class="text-xs text-white/80 flex items-center gap-1">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="size-3">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
              </svg>
              Status da Agenda:
            </span>
            <select [(ngModel)]="statusAgenda" (change)="alterarStatusAgenda()"
              class="rounded px-2 py-0.5 text-xs font-medium"
              style="background-color: rgba(255,255,255,0.2); color: white; border: 1px solid rgba(255,255,255,0.3); outline: none">
              <option value="AR" style="color: var(--tx)">Aguardando Pagamento</option>
              <option value="AC" style="color: var(--tx)">Aguardando Consulta</option>
              <option value="E" style="color: var(--tx)">Executada</option>
            </select>
            <span *ngIf="statusAgendaFeedback" class="text-xs text-white/70">{{ statusAgendaFeedback }}</span>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div *ngIf="isLoadingPagamento" class="flex justify-center py-8">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2" style="border-color: var(--brand-primary)"></div>
      </div>

      <!-- Erro -->
      <div *ngIf="pagamentoErro && !isLoadingPagamento"
        class="rounded-xl p-4 text-sm font-medium flex items-start gap-2 sticky top-0 z-10"
        style="background-color: #fef2f2; color: #dc2626; border: 1px solid #fecaca; box-shadow: 0 2px 8px rgba(220,38,38,0.15)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#dc2626"
          class="size-5 shrink-0 mt-0.5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
        </svg>
        <span>{{ pagamentoErro }}</span>
        <button (click)="pagamentoErro = ''" class="ml-auto shrink-0 p-0.5 rounded hover:bg-red-100"
          style="color: #dc2626">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
            class="size-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Conteúdo financeiro (quando dados carregados e não processado ainda) -->
      <ng-container *ngIf="dadosPagamento && !isLoadingPagamento && !pagamentoResultado">

        <!-- Cards: Saldo do Paciente + Valor Total -->
        <div class="grid grid-cols-2 gap-4">
          <!-- Saldo do Paciente -->
          <div class="rounded-2xl p-4 shadow" style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
            <div class="flex items-center gap-2 mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="var(--brand-secondary)" class="size-5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3" />
              </svg>
              <span class="text-xs font-semibold uppercase" style="color: var(--tx-2)">Saldo do Paciente</span>
            </div>
            <p class="text-lg font-bold" [style.color]="dadosPagamento.vlAdiantamento > 0 ? '#00AC70' : '#4A5D6B'">
              {{ dadosPagamento.vlAdiantamento > 0 ? formatCurrency(dadosPagamento.vlAdiantamento) : 'Sem saldo' }}
            </p>
          </div>

          <!-- Valor Total -->
          <div class="rounded-2xl p-4 shadow" style="background-color: var(--thead)">
            <div class="flex items-center gap-2 mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white"
                class="size-5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
              <span class="text-xs font-semibold uppercase" style="color: rgba(255,255,255,0.8)">Valor Total</span>
            </div>
            <p class="text-2xl font-bold text-white">
              {{ formatCurrency(dadosPagamento.vlTotalConta) }}
            </p>
          </div>
        </div>

        <!-- Resumo Financeiro -->
        <div class="rounded-2xl p-5 shadow" style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
          <div class="flex items-center gap-2 mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              style="stroke: var(--brand-accent)" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
            </svg>
            <span class="text-sm font-semibold uppercase" style="color: var(--brand-accent)">Resumo Financeiro</span>
          </div>
          <div class="space-y-2">
            <div class="flex justify-between text-sm">
              <span style="color: var(--tx-2)">Valor da conta</span>
              <span class="font-semibold" style="color: var(--tx)">{{ formatCurrency(dadosPagamento.vlTotalConta)
                }}</span>
            </div>
            <div *ngIf="dadosPagamento.vlDesconto > 0" class="flex justify-between text-sm">
              <span style="color: var(--tx-2)">Desconto<span *ngIf="dadosPagamento.cupomAplicado"> · {{ dadosPagamento.cupomAplicado }}</span></span>
              <span class="font-semibold" style="color: var(--brand-secondary)">- {{
                formatCurrency(dadosPagamento.vlDesconto) }}</span>
            </div>
            <div *ngIf="dadosPagamento.vlAdiantamento > 0" class="flex justify-between text-sm">
              <span style="color: var(--tx-2)">Adiantamento disponível</span>
              <span class="font-semibold" style="color: var(--tx-2)">{{ formatCurrency(dadosPagamento.vlAdiantamento)
                }}</span>
            </div>
            <div class="border-t pt-2 mt-2 flex justify-between" style="border-color: var(--flua-borda)">
              <span class="text-sm font-bold" style="color: var(--tx)">Valor a receber</span>
              <span class="text-lg font-bold"
                [style.color]="dadosPagamento.vlAdiantamento >= dadosPagamento.vlTotalConta ? '#00AC70' : '#dc2626'">
                {{ dadosPagamento.vlAdiantamento >= dadosPagamento.vlTotalConta ? '✓ Quitado' :
                formatCurrency(dadosPagamento.vlTotalConta - dadosPagamento.vlAdiantamento) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Itens da Conta (sempre aberto, sempre editável) -->
        <div class="rounded-2xl shadow" style="border: 1px solid var(--flua-borda)">
          <div class="px-5 py-3 flex items-center gap-2" style="background-color: var(--cartao)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              style="stroke: var(--brand-accent)" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
            </svg>
            <span class="text-sm font-semibold uppercase" style="color: var(--brand-accent)">Itens da Conta</span>
          </div>

          <div style="border-top: 1px solid var(--flua-borda)">
            <!-- Loading -->
            <div *ngIf="isLoadingItens" class="flex justify-center py-4">
              <div class="animate-spin rounded-full h-5 w-5 border-b-2" style="border-color: var(--brand-primary)">
              </div>
            </div>

            <!-- Tabela -->
            <div *ngIf="!isLoadingItens && itensConta.length > 0">
              <table class="w-full text-xs">
                <thead>
                  <tr style="background-color: var(--thead); color: white">
                    <th class="px-3 py-2.5 text-left font-semibold">Código</th>
                    <th class="px-3 py-2.5 text-left font-semibold">Procedimento</th>
                    <th class="px-3 py-2.5 text-left font-semibold">Médico Executor</th>
                    <th class="px-3 py-2.5 text-center font-semibold">Quantidade</th>
                    <th class="px-3 py-2.5 text-right font-semibold">Valor Unit.</th>
                    <th class="px-3 py-2.5 text-right font-semibold">Valor Total</th>
                    <th *ngIf="editandoItensConta" class="px-3 py-2.5 text-center font-semibold w-10"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of itensConta; let odd = odd; let last = last"
                    [style.background-color]="odd ? '#F9F5EC' : 'white'">
                    <td class="px-3 py-2.5" style="color: var(--tx-2)">{{ item.nrSeqProcInterno }}</td>
                    <td class="px-3 py-2.5 font-medium" style="color: var(--tx)">{{ item.dsProcedimento }}</td>

                    <!-- Médico Executor -->
                    <td class="px-3 py-2.5 relative" style="color: var(--tx-2)">
                      <!-- Modo leitura -->
                      <span *ngIf="!editandoItensConta && !item.editandoMedico">{{ item.nomeMedico || '—' }}</span>
                      <!-- Modo edição: nome clicável para editar -->
                      <span *ngIf="editandoItensConta && !item.editandoMedico" (click)="toggleEditarMedico(item)"
                        class="cursor-pointer underline decoration-dotted" style="color: var(--brand-primary)"
                        title="Clique para alterar">{{ item.nomeMedico || '—' }}</span>
                      <!-- Input de busca -->
                      <div *ngIf="item.editandoMedico" class="relative">
                        <input type="text" [(ngModel)]="item.medicoBusca" (input)="filtrarMedicosItem(item)"
                          (focus)="filtrarMedicosItem(item)" placeholder="Buscar médico..."
                          class="w-full text-xs px-2 py-1 rounded border"
                          style="border-color: var(--flua-borda); outline: none" />
                        <div *ngIf="item.showMedicoDropdown"
                          class="absolute z-10 left-0 right-0 rounded-lg shadow-lg overflow-hidden"
                          [style]="'background-color: var(--cartao); border: 1px solid var(--flua-borda); max-height: 150px; overflow-y: auto;' + (last ? 'bottom: 100%; margin-bottom: 2px' : 'top: 100%; margin-top: 4px')">
                          <div *ngFor="let m of item.medicosFiltrados" (mousedown)="selecionarMedicoItem(item, m)"
                            class="px-2 py-1.5 text-xs cursor-pointer hover:bg-gray-100" style="color: var(--tx)">
                            {{ m.nmGuerra }}<span *ngIf="m.isParceiro" class="ml-1 text-[10px]" style="color: var(--tx-2)">parceiro</span>
                          </div>
                        </div>
                      </div>
                    </td>

                    <!-- Quantidade -->
                    <td class="px-3 py-2.5">
                      <!-- Modo leitura -->
                      <div *ngIf="!editandoItensConta" class="text-center font-semibold" style="color: var(--tx)">
                        {{ item.qtProcedimento }}
                      </div>
                      <!-- Modo edição -->
                      <div *ngIf="editandoItensConta" class="flex items-center justify-center gap-1">
                        <button (click)="alterarQuantidadeItem(item, -1)" [disabled]="item.qtProcedimento <= 1"
                          class="w-5 h-5 rounded flex items-center justify-center text-xs"
                          [style.color]="item.qtProcedimento <= 1 ? '#E5DFD4' : '#4A5D6B'"
                          [style.border]="'1px solid ' + (item.qtProcedimento <= 1 ? '#E5DFD4' : '#4A5D6B')"
                          [style.cursor]="item.qtProcedimento <= 1 ? 'not-allowed' : 'pointer'"
                          style="background: var(--cartao)">−</button>
                        <span class="w-5 text-center font-semibold text-xs" style="color: var(--tx)">{{
                          item.qtProcedimento }}</span>
                        <button (click)="alterarQuantidadeItem(item, 1)"
                          class="w-5 h-5 rounded flex items-center justify-center text-xs"
                          style="border: 1px solid #4A5D6B; color: var(--tx-2); background: var(--cartao); cursor: pointer">+</button>
                      </div>
                    </td>

                    <td class="px-3 py-2.5 text-right" style="color: var(--tx-2)">
                      {{ formatCurrency(item.vlUnitario || 0) }}
                    </td>
                    <td class="px-3 py-2.5 text-right font-semibold" style="color: var(--tx)">
                      {{ formatCurrency((item.vlUnitario || 0) * item.qtProcedimento) }}
                    </td>

                    <!-- Excluir (só no modo edição) -->
                    <td *ngIf="editandoItensConta" class="px-3 py-2.5 text-center">
                      <button (click)="removerItemConta(item)" class="p-1 rounded hover:bg-gray-100"
                        style="color: var(--tx-2); cursor: pointer" title="Remover item">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                          stroke="currentColor" class="size-3.5">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                        </svg>
                      </button>
                    </td>
                  </tr>

                  <!-- Nova linha para adicionar procedimento -->
                  <tr *ngIf="adicionandoProcedimento" style="background-color: var(--brand-surface)">
                    <td class="px-3 py-2.5" style="color: var(--tx-2)">—</td>
                    <td class="px-3 py-2.5 relative" colspan="2">
                      <div class="relative">
                        <input type="text" [(ngModel)]="novoProcBusca" (input)="filtrarNovoProcedimento()"
                          (focus)="filtrarNovoProcedimento()" placeholder="Buscar procedimento por nome ou código..."
                          class="w-full text-xs px-2 py-1.5 rounded border"
                          style="border-color: var(--flua-borda); outline: none" />
                        <div *ngIf="showNovoProcDropdown"
                          class="absolute z-10 left-0 right-0 mt-1 rounded-lg shadow-lg overflow-hidden"
                          style="background-color: var(--cartao); border: 1px solid var(--flua-borda); max-height: 180px; overflow-y: auto">
                          <div *ngFor="let p of novoProcFiltrados" (mousedown)="selecionarNovoProcedimento(p)"
                            class="px-3 py-2 text-xs cursor-pointer hover:bg-gray-100" style="color: var(--tx)">
                            <span class="font-medium">{{ p.dsProcExame }}</span>
                            <span class="ml-1" style="color: var(--tx-2)">({{ p.cdProcedimento }})</span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="px-3 py-2.5">
                      <div class="flex items-center justify-center gap-1">
                        <button (click)="novoProcQtd > 1 && (novoProcQtd = novoProcQtd - 1)"
                          [disabled]="novoProcQtd <= 1" class="w-5 h-5 rounded flex items-center justify-center text-xs"
                          [style.color]="novoProcQtd <= 1 ? '#E5DFD4' : '#4A5D6B'"
                          [style.border]="'1px solid ' + (novoProcQtd <= 1 ? '#E5DFD4' : '#4A5D6B')"
                          style="background: var(--cartao)">−</button>
                        <span class="w-5 text-center font-semibold text-xs" style="color: var(--tx)">{{ novoProcQtd
                          }}</span>
                        <button (click)="novoProcQtd = novoProcQtd + 1"
                          class="w-5 h-5 rounded flex items-center justify-center text-xs"
                          style="border: 1px solid #4A5D6B; color: var(--tx-2); background: var(--cartao); cursor: pointer">+</button>
                      </div>
                    </td>
                    <td class="px-3 py-2.5 text-right" style="color: var(--tx-2)">—</td>
                    <td class="px-3 py-2.5 text-right" style="color: var(--tx-2)">—</td>
                    <td *ngIf="editandoItensConta" class="px-3 py-2.5 text-center">
                      <div class="flex items-center justify-center gap-1">
                        <button (click)="confirmarAdicionarProcedimento()"
                          [disabled]="!novoProcSelecionado || isAdicionandoProc" class="p-2 rounded-lg"
                          [style.color]="novoProcSelecionado ? '#00AC70' : '#E5DFD4'"
                          [style.cursor]="novoProcSelecionado ? 'pointer' : 'not-allowed'"
                          [style.backgroundColor]="novoProcSelecionado ? '#f0fdf4' : 'transparent'" title="Confirmar">
                          <div *ngIf="isAdicionandoProc" class="animate-spin rounded-full h-5 w-5 border-b-2"
                            style="border-color: var(--brand-primary)"></div>
                          <svg *ngIf="!isAdicionandoProc" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="size-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                          </svg>
                        </button>
                        <button (click)="cancelarAdicionarProcedimento()" class="p-2 rounded-lg hover:bg-gray-100"
                          style="color: var(--tx-2); cursor: pointer" title="Cancelar">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                            stroke="currentColor" class="size-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Sem itens -->
            <div *ngIf="!isLoadingItens && itensConta.length === 0" class="px-5 py-4 text-center text-xs"
              style="color: var(--tx-2)">
              Nenhum item encontrado na conta.
            </div>

            <!-- Total -->
            <div *ngIf="!isLoadingItens && itensConta.length > 0" class="px-4 py-3 flex justify-between items-center"
              style="background-color: var(--brand-surface); border-top: 1px solid var(--flua-borda)">
              <span class="text-xs font-semibold" style="color: var(--tx-2)">
                TOTAL ({{ itensConta.length }} {{ itensConta.length === 1 ? 'item' : 'itens' }}):
              </span>
              <span class="text-sm font-bold" style="color: var(--brand-primary)">
                {{ formatCurrency(dadosPagamento.vlTotalConta) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Barra de ações -->
        <div class="rounded-2xl px-4 py-3 shadow flex items-center justify-between gap-2"
          style="background-color: var(--brand-surface); border: 1px solid var(--flua-borda)">
          <div class="flex items-center gap-2">
            <button (click)="abrirAdicionarProcedimento()"
              class="px-4 py-2.5 rounded-lg text-xs font-semibold flex items-center gap-1.5"
              style="border: 1px solid var(--brand-primary); color: var(--brand-primary); background-color: var(--cartao)"
              onmouseover="this.style.backgroundColor='var(--brand-surface)'" onmouseout="this.style.backgroundColor='white'">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
              </svg>
              Adicionar Procedimentos
            </button>
            <button (click)="abrirOrcamentoPagamento()"
              class="px-4 py-2.5 rounded-lg text-xs font-semibold flex items-center gap-1.5"
              style="border: 1px solid var(--brand-primary); color: var(--brand-primary); background-color: var(--cartao)"
              onmouseover="this.style.backgroundColor='var(--brand-surface)'" onmouseout="this.style.backgroundColor='white'">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
              </svg>
              Adicionar Orçamento
            </button>
            <button (click)="abrirCupomModal()"
              class="px-4 py-2.5 rounded-lg text-xs font-semibold flex items-center gap-1.5"
              style="border: 1px solid #f59e0b; color: #f59e0b; background-color: var(--cartao)"
              onmouseover="this.style.backgroundColor='#fffbeb'" onmouseout="this.style.backgroundColor='white'">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z" />
              </svg>
              Adicionar Cupom
            </button>
          </div>
          <div class="flex items-center gap-2">
            <button (click)="pularPagamento()"
              class="px-4 py-2.5 rounded-lg text-xs font-semibold flex items-center gap-1.5"
              style="background-color: #4A5D6B; color: white" onmouseover="this.style.backgroundColor='#4A5D6B'"
              onmouseout="this.style.backgroundColor='#4A5D6B'">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M3 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061A1.125 1.125 0 0 1 3 16.811V8.69ZM12.75 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061a1.125 1.125 0 0 1-1.683-.977V8.69Z" />
              </svg>
              Pular Pagamento
            </button>
            <button (click)="abrirMaquinetaModal()"
              class="px-4 py-2.5 rounded-lg text-xs font-semibold flex items-center gap-1.5"
              style="background-color: var(--brand-secondary); color: white"
              onmouseover="this.style.filter='brightness(0.9)'" onmouseout="this.style.filter=''">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
              </svg>
              Cobrar na Maquineta
            </button>
            <button *ngIf="hasCaixaAccess" (click)="abrirCaixaModal()"
              class="px-4 py-2.5 rounded-lg text-xs font-semibold flex items-center gap-1.5"
              style="background-color: #f59e0b; color: white" onmouseover="this.style.backgroundColor='#d97706'"
              onmouseout="this.style.backgroundColor='#f59e0b'">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z" />
              </svg>
              Pagamento em Espécie
            </button>
            <button (click)="processarPagamento()" [disabled]="isProcessingPagamento"
              class="px-5 py-2.5 rounded-lg text-xs font-semibold text-white flex items-center gap-1.5"
              [style.backgroundColor]="isProcessingPagamento ? '#D6CFC2' : 'var(--brand-primary)'"
              [style.cursor]="isProcessingPagamento ? 'not-allowed' : 'pointer'"
              onmouseover="if(!this.disabled) this.style.backgroundColor='var(--brand-ink)'"
              onmouseout="if(!this.disabled) this.style.backgroundColor='var(--brand-primary)'">
              <div *ngIf="isProcessingPagamento" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white">
              </div>
              <svg *ngIf="!isProcessingPagamento" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="2" stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
              {{ isProcessingPagamento ? 'Processando...' : 'Processar Pagamento' }}
            </button>
          </div>
        </div>

      </ng-container>

      <!-- Sem dados de conta -->
      <div *ngIf="!dadosPagamento && !isLoadingPagamento && !pagamentoErro" class="rounded-2xl p-5 shadow text-center"
        style="background-color: var(--brand-surface)">
        <p class="text-sm" style="color: var(--tx-2)">Nenhuma conta encontrada para este atendimento.</p>
        <button (click)="pularPagamento()" class="mt-3 px-5 py-2 rounded-lg text-white text-sm font-semibold"
          style="background-color: var(--brand-primary)" onmouseover="this.style.backgroundColor='var(--brand-ink)'"
          onmouseout="this.style.backgroundColor='var(--brand-primary)'">
          Voltar ao Dashboard
        </button>
      </div>

      <!-- ═══ Step 5 — Conclusão (após pagamento processado) ═══ -->
      <div *ngIf="pagamentoResultado && !isLoadingPagamento" class="space-y-4">

        <!-- Banner -->
        <div class="rounded-2xl px-5 py-4 flex items-center gap-3"
          [style.backgroundColor]="pagamentoPulado ? '#f59e0b' : '#00AC70'">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="white"
            class="size-7 shrink-0">
            <path *ngIf="!pagamentoPulado" stroke-linecap="round" stroke-linejoin="round"
              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            <path *ngIf="pagamentoPulado" stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
          </svg>
          <div class="flex-1">
            <p class="font-semibold text-white text-sm">{{ pagamentoPulado ? 'Pagamento Pendente' : 'Pagamento
              Processado com Sucesso!' }}</p>
            <div class="flex gap-4 mt-1 text-xs text-white/90">
              <span>Atendimento: <strong class="text-white">#{{ resultado?.nrAtendimento }}</strong></span>
              <span>Valor: <strong class="text-white">{{ formatCurrency(pagamentoResultado.vlContaFinal)
                  }}</strong></span>
              <span *ngIf="!pagamentoPulado">Título: <strong class="text-white">#{{ pagamentoResultado.nrTitulo || '—'
                  }}</strong></span>
            </div>
          </div>
        </div>

        <!-- Info bar: Paciente + Tipo + Médico + Atendimento -->
        <div class="rounded-2xl px-5 py-3 flex items-center gap-6 flex-wrap text-xs"
          style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
          <div class="flex items-center gap-1.5">
            <span class="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold text-white"
              style="background-color: var(--brand-secondary)">1</span>
            <div><span class="uppercase font-semibold" style="color: var(--tx-2)">Paciente</span>
              <p class="font-semibold" style="color: var(--tx)">{{ resultado?.nmPaciente }}</p>
            </div>
          </div>
          <div class="flex items-center gap-1.5">
            <span class="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold text-white"
              style="background-color: var(--brand-secondary)">2</span>
            <div><span class="uppercase font-semibold" style="color: var(--tx-2)">Tipo</span>
              <p class="font-semibold" style="color: var(--tx)">{{ resultado?.tipoAtendimento }}</p>
            </div>
          </div>
          <div *ngIf="selectedAgenda?.doctorName" class="flex items-center gap-1.5">
            <span class="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold text-white"
              style="background-color: var(--brand-secondary)">3</span>
            <div><span class="uppercase font-semibold" style="color: var(--tx-2)">Médico</span>
              <p class="font-semibold" style="color: var(--tx)">{{ selectedAgenda.doctorName }}</p>
            </div>
          </div>
          <div class="flex items-center gap-1.5">
            <span class="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold text-white"
              style="background-color: var(--brand-secondary)">4</span>
            <div><span class="uppercase font-semibold" style="color: var(--tx-2)">Atendimento</span>
              <p class="font-semibold" style="color: var(--tx)">#{{ resultado?.nrAtendimento }}</p>
            </div>
          </div>
        </div>

        <!-- Loading resumo -->
        <div *ngIf="isLoadingResumo" class="flex justify-center py-4">
          <div class="animate-spin rounded-full h-6 w-6 border-b-2" style="border-color: var(--brand-secondary)"></div>
        </div>

        <!-- Cards: Resumo Financeiro + Baixa/Pagamento -->
        <div class="grid grid-cols-2 gap-4">
          <!-- Resumo Financeiro -->
          <div class="rounded-2xl p-5 shadow" style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
            <div class="flex items-center gap-2 mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                style="stroke: var(--brand-accent)" class="size-5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
              </svg>
              <span class="text-sm font-semibold" style="color: var(--brand-accent)">Resumo Financeiro</span>
            </div>
            <div class="space-y-2 text-sm">
              <div class="flex justify-between">
                <span style="color: var(--tx-2)">Valor da conta</span>
                <span class="font-semibold" style="color: var(--tx)">{{ formatCurrency(resumoConclusao?.vlConta ??
                  pagamentoResultado.vlContaFinal) }}</span>
              </div>
              <div class="flex justify-between">
                <span style="color: var(--tx-2)">Baixado</span>
                <span class="font-semibold" style="color: var(--tx)">{{ formatCurrency(pagamentoPulado ? 0 :
                  (resumoConclusao?.vlBaixado ?? 0)) }}</span>
              </div>
              <div
                *ngIf="!pagamentoPulado && (resumoConclusao?.vlAdiantamento ?? 0) > 0 && (resumoConclusao?.vlSaldoPendente ?? 0) <= 0"
                class="flex justify-between">
                <span style="color: var(--tx-2)">Adiantamento</span>
                <span class="font-semibold" style="color: var(--brand-secondary)">{{
                  formatCurrency(resumoConclusao?.vlAdiantamento ?? 0) }}</span>
              </div>
              <div class="flex justify-between border-t pt-2" style="border-color: var(--flua-borda)">
                <span style="color: var(--tx-2)">Saldo Pendente</span>
                <span class="font-semibold"
                  [style.color]="pagamentoPulado ? '#dc2626' : ((resumoConclusao?.vlSaldoPendente ?? 0) <= 0 ? '#00AC70' : '#dc2626')">
                  {{ pagamentoPulado ? formatCurrency(pagamentoResultado.vlContaFinal) :
                  ((resumoConclusao?.vlSaldoPendente ?? 0) <= 0 ? '✓ Quitado' :
                    formatCurrency(resumoConclusao?.vlSaldoPendente ?? 0)) }} </span>
              </div>
              <div class="flex justify-between">
                <span style="color: var(--tx-2)">Status</span>
                <span class="font-semibold" style="color: var(--tx)">{{ pagamentoPulado ? 'Provisório' :
                  (resumoConclusao?.statusConta || 'Definitivo') }}</span>
              </div>
            </div>
          </div>

          <!-- Baixa / Pagamento -->
          <div *ngIf="!pagamentoPulado" class="rounded-2xl p-5 shadow"
            style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
            <div class="flex items-center gap-2 mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="var(--brand-secondary)" class="size-5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
              </svg>
              <span class="text-sm font-semibold" style="color: var(--brand-accent)">Baixa / Pagamento</span>
            </div>
            <div class="space-y-2 text-sm">
              <div class="flex justify-between">
                <span style="color: var(--tx-2)">Título</span>
                <span class="font-semibold" style="color: var(--tx)">#{{ pagamentoResultado.nrTitulo || '—' }}</span>
              </div>
              <div class="flex justify-between">
                <span style="color: var(--tx-2)">Total</span>
                <span class="font-semibold" style="color: var(--tx)">{{ formatCurrency(resumoConclusao?.vlConta ??
                  pagamentoResultado.vlContaFinal) }}</span>
              </div>
              <div class="flex justify-between">
                <span style="color: var(--tx-2)">Baixado</span>
                <span class="font-semibold" style="color: var(--tx)">{{ formatCurrency(resumoConclusao?.vlBaixado ?? 0)
                  }}</span>
              </div>
              <div *ngIf="(resumoConclusao?.vlAdiantamento ?? 0) > 0 && (resumoConclusao?.vlSaldoPendente ?? 0) <= 0"
                class="flex justify-between">
                <span style="color: var(--tx-2)">Adiantamento</span>
                <span class="font-semibold" style="color: var(--brand-secondary)">{{
                  formatCurrency(resumoConclusao?.vlAdiantamento ?? 0) }}</span>
              </div>
              <div class="flex justify-between border-t pt-2" style="border-color: var(--flua-borda)">
                <span style="color: var(--tx-2)">Saldo Pendente</span>
                <span class="font-semibold"
                  [style.color]="(resumoConclusao?.vlSaldoPendente ?? 0) <= 0 ? '#00AC70' : '#dc2626'">
                  {{ (resumoConclusao?.vlSaldoPendente ?? 0) <= 0 ? '✓ Quitado' :
                    formatCurrency(resumoConclusao?.vlSaldoPendente ?? 0) }} </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Adiantamentos Aplicados -->
        <div *ngIf="resumoConclusao?.adiantamentosAplicados?.length" class="rounded-2xl shadow overflow-hidden"
          style="border: 1px solid var(--flua-borda)">
          <div class="px-5 py-3 flex items-center gap-2" style="background-color: var(--cartao)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#f59e0b"
              class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3" />
            </svg>
            <span class="text-sm font-semibold" style="color: var(--brand-accent)">Adiantamentos Aplicados</span>
          </div>
          <table class="w-full text-xs" style="border-top: 1px solid var(--flua-borda)">
            <thead>
              <tr style="background-color: var(--thead); color: white">
                <th class="px-3 py-2.5 text-left font-semibold">N°</th>
                <th class="px-3 py-2.5 text-left font-semibold">Data</th>
                <th class="px-3 py-2.5 text-left font-semibold">Estabelecimento</th>
                <th class="px-3 py-2.5 text-right font-semibold">Vl. Original</th>
                <th class="px-3 py-2.5 text-right font-semibold">Saldo Atual</th>
                <th class="px-3 py-2.5 text-left font-semibold">Obs.</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let adian of resumoConclusao!.adiantamentosAplicados; let odd = odd"
                [style.background-color]="odd ? '#F9F5EC' : 'white'">
                <td class="px-3 py-2.5 font-semibold" style="color: var(--brand-primary)">#{{ adian.nrAdiantamento }}
                </td>
                <td class="px-3 py-2.5" style="color: var(--tx-2)">{{ adian.dtAdiantamento }}</td>
                <td class="px-3 py-2.5" style="color: var(--tx)">{{ adian.estabelecimento }}</td>
                <td class="px-3 py-2.5 text-right font-semibold" style="color: var(--tx)">{{
                  formatCurrency(adian.vlOriginal) }}</td>
                <td class="px-3 py-2.5 text-right" style="color: var(--tx-2)">{{ formatCurrency(adian.vlSaldoAtual) }}</td>
                <td class="px-3 py-2.5" style="color: var(--tx-2)">{{ adian.dsObservacao || '—' }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="background-color: var(--brand-surface); border-top: 2px solid var(--flua-borda)">
                <td colspan="3" class="px-3 py-2.5 text-right font-bold text-xs" style="color: var(--brand-accent)">
                  TOTAL ({{ resumoConclusao!.adiantamentosAplicados.length }} {{
                  resumoConclusao!.adiantamentosAplicados.length === 1 ? 'adiantamento' : 'adiantamentos' }}):
                </td>
                <td class="px-3 py-2.5 text-right font-bold text-xs" style="color: var(--brand-secondary)">
                  {{ formatCurrency(resumoConclusao!.adiantamentosAplicados.reduce(sumVlOriginal, 0)) }}
                </td>
                <td class="px-3 py-2.5 text-right font-bold text-xs" style="color: var(--tx-2)">
                  {{ formatCurrency(resumoConclusao!.adiantamentosAplicados.reduce(sumVlSaldoAtual, 0)) }}
                </td>
                <td class="px-3 py-2.5"></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- Nota Fiscal -->
        <div *ngIf="resumoConclusao?.notasFiscais?.length" class="rounded-2xl shadow overflow-hidden"
          style="border: 1px solid var(--flua-borda)">
          <div class="px-5 py-3 flex items-center gap-2" style="background-color: var(--cartao)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              style="stroke: var(--brand-accent)" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
            </svg>
            <span class="text-sm font-semibold" style="color: var(--brand-accent)">Nota Fiscal</span>
          </div>
          <table class="w-full text-xs" style="border-top: 1px solid var(--flua-borda)">
            <thead>
              <tr style="background-color: var(--thead); color: white">
                <th class="px-3 py-2.5 text-left font-semibold">NF</th>
                <th class="px-3 py-2.5 text-left font-semibold">RPS</th>
                <th class="px-3 py-2.5 text-left font-semibold">Emissão</th>
                <th class="px-3 py-2.5 text-right font-semibold">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let nf of resumoConclusao!.notasFiscais; let odd = odd"
                [style.background-color]="odd ? '#F9F5EC' : 'white'">
                <td class="px-3 py-2.5" style="color: var(--tx)">{{ nf.nrNotaFiscal || '—' }}</td>
                <td class="px-3 py-2.5" style="color: var(--tx-2)">{{ nf.nrRps }}</td>
                <td class="px-3 py-2.5" style="color: var(--tx-2)">{{ nf.dtEmissao }}</td>
                <td class="px-3 py-2.5 text-right font-semibold" style="color: var(--tx)">{{ formatCurrency(nf.vlNota) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Botões: Ver Ficha (PDF) + Concluir -->
        <div class="flex justify-end gap-3">
          <button (click)="verFichaPdf()" class="px-5 py-2.5 rounded-lg text-sm font-semibold flex items-center gap-2"
            style="background-color: var(--cartao); color: var(--brand-accent); border: 1px solid var(--flua-borda)"
            onmouseover="this.style.backgroundColor='var(--brand-surface)'" onmouseout="this.style.backgroundColor='white'">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
            </svg>
            Ver Ficha (PDF)
          </button>
          <button (click)="voltarDashboard()"
            class="px-6 py-2.5 rounded-lg text-white text-sm font-semibold flex items-center gap-2"
            style="background-color: var(--brand-secondary)" onmouseover="this.style.filter='brightness(0.9)'"
            onmouseout="this.style.filter=''">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
            </svg>
            Concluir
          </button>
        </div>

        <!-- Aviso de Termos (TCLE) abertos para impressão -->
        <div *ngIf="tclesEncontrados.length > 0" class="mt-3 rounded-xl px-4 py-3 flex flex-col gap-1.5"
          style="background-color: #fffbeb; border: 1px solid #fbbf24">
          <div class="flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#d97706"
              class="size-4 shrink-0">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
            </svg>
            <span class="text-xs font-semibold" style="color: #92400e">
              {{ tclesEncontrados.length }} termo(s) de consentimento aberto(s) para impressão:
            </span>
          </div>
          <ul class="ml-6 list-disc">
            <li *ngFor="let t of tclesEncontrados" class="text-xs" style="color: #78350f">
              {{ t.nome }}
            </li>
          </ul>
        </div>

      </div>

    </div>

  </div>

  <!-- Modal Concluir Atendimento -->
  @if (showConcluirModal) {
  <div class="fixed inset-0 z-[9999] flex items-center justify-center" style="background: rgba(0,0,0,0.5)">
    <div class="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md mx-4">
      <div class="flex items-center gap-3 mb-4">
        <div class="flex items-center justify-center w-12 h-12 rounded-full" style="background-color: #f0fdf4">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#00AC70"
            class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </div>
        <div>
          <h3 class="text-lg font-bold" style="color: var(--brand-accent)">Atendimento aberto</h3>
          <p class="text-sm" style="color: var(--tx-2)">O que deseja fazer agora?</p>
        </div>
      </div>
      <div *ngIf="concluirErro" class="mb-3 px-4 py-2 rounded-lg text-sm"
        style="background-color: #fef2f2; color: #991b1b; border: 1px solid #fecaca">
        {{ concluirErro }}
      </div>
      <div class="flex flex-col gap-3">
        <button (click)="confirmarNovoAtendimento()" [disabled]="isFinalizandoSenha"
          class="w-full px-6 py-3 rounded-lg text-white text-sm font-semibold"
          style="background-color: var(--brand-secondary)" onmouseover="this.style.filter='brightness(0.9)'"
          onmouseout="this.style.filter=''">
          Abrir novo atendimento
        </button>
        <button (click)="confirmarFinalizar()" [disabled]="isFinalizandoSenha"
          class="w-full px-6 py-3 rounded-lg text-sm font-semibold flex items-center justify-center gap-2"
          style="color: var(--tx-2); background-color: var(--flua-fundo); border: 1px solid var(--flua-borda)"
          onmouseover="this.style.backgroundColor='#E5DFD4'" onmouseout="this.style.backgroundColor='#F4F1EA'">
          <span *ngIf="isFinalizandoSenha"
            class="h-4 w-4 animate-spin rounded-full border-2 border-gray-400 border-t-transparent"></span>
          {{ isFinalizandoSenha ? 'Encerrando...' : 'Finalizar senha' }}
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Modal HRA Pendente -->
  @if (showHraModal) {
  <div class="fixed inset-0 z-[9999] flex items-center justify-center" style="background: rgba(0,0,0,0.5)">
    <div class="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md mx-4">
      <!-- Header -->
      <div class="flex items-center gap-3 mb-4">
        <div class="flex items-center justify-center w-12 h-12 rounded-full" style="background-color: #fff7ed">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#c2410c"
            class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
          </svg>
        </div>
        <div>
          <h3 class="text-lg font-bold" style="color: #c2410c">HRA Pendente</h3>
          <p class="text-sm" style="color: var(--tx-2)">Questionário de saúde não preenchido</p>
        </div>
      </div>

      <!-- Conteúdo -->
      <div class="rounded-xl p-4 mb-5" style="background-color: #fff7ed; border: 1px solid #fed7aa">
        <p class="text-sm font-semibold mb-2" style="color: #9a3412">
          O paciente não preencheu o questionário de saúde!
        </p>
        <p class="text-sm" style="color: #9a3412">
          Peça ao paciente para preencher o que foi enviado no WhatsApp.
        </p>
        <p class="text-sm mt-2" style="color: #9a3412">
          Justifique que enquanto aguarda o chamado, agiliza o atendimento e ajuda o médico a se preparar.
        </p>
      </div>

      <!-- QR Code da unidade -->
      @if (qrCodeHraPath) {
      <div class="flex flex-col items-center mb-5">
        <p class="text-sm font-semibold mb-3" style="color: var(--brand-accent)">
          Ou peça para escanear o QR Code abaixo:
        </p>
        <img [src]="qrCodeHraPath" alt="QR Code HRA" class="w-48 h-48 rounded-lg" />
      </div>
      }

      <!-- Botões -->
      <div class="flex justify-center gap-3">
        <button (click)="showHraModal = false" class="px-6 py-2.5 rounded-lg text-sm font-semibold"
          style="color: var(--tx-2); background-color: var(--flua-fundo); border: 1px solid var(--flua-borda)"
          onmouseover="this.style.backgroundColor='#E5DFD4'" onmouseout="this.style.backgroundColor='#F4F1EA'">
          Descartar
        </button>
        <button (click)="voltarDashboard()" class="px-6 py-2.5 rounded-lg text-white text-sm font-semibold"
          style="background-color: var(--brand-secondary)" onmouseover="this.style.filter='brightness(0.9)'"
          onmouseout="this.style.filter=''">
          Entendi, concluir
        </button>
      </div>
    </div>
  </div>
  }
</body>

<!-- ════════════════════════════════════════════════════════════
     MODAL — SELECIONAR ORÇAMENTO
     ════════════════════════════════════════════════════════════ -->
<!-- Modal: Tabela de Procedimentos do Convênio ("Ver tabela") -->
<div *ngIf="isTabelaModalOpen" class="fixed inset-0 z-50 flex justify-center"
  style="background-color: rgba(0,0,0,0.5); overflow-y: auto; padding: 40px 0">

  <div class="rounded-2xl shadow-xl w-full max-w-2xl mx-4"
    style="background-color: var(--cartao); height: fit-content; align-self: flex-start" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="px-5 py-4 flex items-center justify-between"
      style="border-bottom: 1px solid var(--flua-borda); background-color: var(--brand-surface); border-radius: 16px 16px 0 0">
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="var(--brand-primary)" class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6h16.5M3.75 12h16.5m-16.5 6h16.5" />
        </svg>
        <p class="font-semibold text-sm" style="color: var(--tx)">Procedimentos do Convênio</p>
      </div>
      <button (click)="fecharTabelaProcedimentos()" class="p-1 rounded-lg" style="color: var(--tx-2)"
        onmouseover="this.style.backgroundColor='#F4F1EA'" onmouseout="this.style.backgroundColor='transparent'">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
          class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="px-5 py-4 flex flex-col gap-3">

      <!-- Busca em toda a tabela -->
      <input type="text" [(ngModel)]="tabelaBusca" (ngModelChange)="buscarNaTabela()"
        placeholder="Buscar em toda a tabela..."
        class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
        style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />

      <!-- Spinner -->
      <div *ngIf="tabelaLoading" class="flex justify-center py-8">
        <div class="h-8 w-8 animate-spin rounded-full border-4 border-gray-200"
          style="border-top-color: var(--brand-primary)"></div>
      </div>

      <!-- Categorias -->
      <div *ngIf="!tabelaLoading && !tabelaClassifSelecionada && !tabelaProcedimentos.length"
        class="grid grid-cols-2 md:grid-cols-3 gap-2">
        <button *ngFor="let c of tabelaClassificacoes" type="button" (click)="selecionarClassificacaoTabela(c)"
          class="flex items-center justify-between gap-2 px-3 py-2.5 rounded-lg border text-sm text-left"
          style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)"
          onmouseover="this.style.backgroundColor='var(--brand-surface)'" onmouseout="this.style.backgroundColor='white'">
          <span class="truncate">{{ c.dsClassificacao }}</span>
          <span class="text-xs font-semibold px-2 py-0.5 rounded-full flex-shrink-0"
            style="background-color: var(--flua-fundo); color: var(--brand-primary)">{{ c.qtProcedimentos }}</span>
        </button>
        <div *ngIf="!tabelaClassificacoes.length" class="col-span-full text-center py-8 text-sm"
          style="color: var(--tx-2)">Nenhuma categoria com preço para este convênio.</div>
      </div>

      <!-- Itens da categoria / resultado da busca -->
      <div *ngIf="!tabelaLoading && (tabelaClassifSelecionada || tabelaProcedimentos.length)">
        <button *ngIf="tabelaClassifSelecionada" type="button" (click)="voltarParaClassificacoes()"
          class="flex items-center gap-1 text-xs font-medium mb-2" style="color: var(--brand-primary)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor" class="size-3.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>
          {{ tabelaClassifSelecionada.dsClassificacao }} — voltar às categorias
        </button>

        <div class="overflow-y-auto rounded-lg" style="max-height: 340px; border: 1px solid #F4F1EA">
          <div *ngFor="let proc of tabelaProcedimentos" (click)="toggleTabelaProc(proc)"
            class="px-4 py-2.5 cursor-pointer text-sm flex items-center gap-3"
            [ngStyle]="tabelaSelecionados.has(proc.cdProcedimento)
              ? { 'background-color': 'var(--brand-surface)', 'border-left': '3px solid var(--brand-primary)' }
              : { 'border-left': '3px solid transparent' }"
            style="border-bottom: 1px solid #F4F1EA">
            <input type="checkbox" [checked]="tabelaSelecionados.has(proc.cdProcedimento)" class="pointer-events-none" />
            <div class="min-w-0 flex-1">
              <p class="font-medium truncate" style="color: var(--tx)">{{ proc.dsProcExame }}</p>
              <p class="text-xs mt-0.5" style="color: var(--tx-2)">Código: {{ proc.cdProcedimento }}</p>
            </div>
            <span class="text-xs font-semibold whitespace-nowrap px-2 py-0.5 rounded"
              style="background-color: #e7f6ef; color: #1d7a55">{{ formatarPrecoProc(proc) }}</span>
          </div>
          <div *ngIf="!tabelaProcedimentos.length" class="text-center py-8 text-sm" style="color: var(--tx-2)">
            Nenhum procedimento encontrado.
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-5 py-3 flex items-center justify-between"
      style="border-top: 1px solid var(--flua-borda); background-color: var(--brand-surface); border-radius: 0 0 16px 16px">
      <p class="text-xs" style="color: var(--tx-2)">
        {{ tabelaSelecionados.size === 0 ? 'Nenhum procedimento selecionado'
           : tabelaSelecionados.size + ' selecionado(s)' }}
      </p>
      <button type="button" (click)="adicionarSelecionadosTabela()" [disabled]="tabelaSelecionados.size === 0"
        class="px-4 py-2 rounded-lg text-sm font-medium"
        [ngStyle]="tabelaSelecionados.size === 0
          ? { 'background-color': '#E5DFD4', color: 'white', cursor: 'not-allowed' }
          : { 'background-color': 'var(--brand-primary)', color: 'white', cursor: 'pointer' }">
        + Adicionar selecionados
      </button>
    </div>
  </div>
</div>

<div *ngIf="showOrcamentoModal" class="fixed inset-0 z-50 flex justify-center"
  style="background-color: rgba(0,0,0,0.5); overflow-y: auto; padding: 40px 0">

  <div class="rounded-2xl shadow-xl w-full max-w-lg mx-4"
    style="background-color: var(--cartao); height: fit-content; align-self: flex-start" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="px-5 py-4 flex items-center justify-between"
      style="border-bottom: 1px solid var(--flua-borda); background-color: var(--brand-surface); border-radius: 16px 16px 0 0">
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="var(--brand-primary)" class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
        </svg>
        <p class="font-semibold text-sm" style="color: var(--tx)">Selecionar Orçamento</p>
      </div>
      <button (click)="fecharOrcamentoModal()" class="p-1 rounded-lg" style="color: var(--tx-2)"
        onmouseover="this.style.backgroundColor='#F4F1EA'" onmouseout="this.style.backgroundColor='transparent'">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
          class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="px-5 py-4 flex flex-col gap-4">

      <!-- Spinner -->
      <div *ngIf="isLoadingOrcamentos" class="flex justify-center py-10">
        <div class="h-8 w-8 animate-spin rounded-full border-4 border-gray-200"
          style="border-top-color: var(--brand-primary)"></div>
      </div>

      <!-- Sem orçamentos -->
      <div *ngIf="!isLoadingOrcamentos && orcamentoGroups.length === 0" class="flex flex-col items-center py-10 gap-2"
        style="color: var(--tx-2)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="size-10 opacity-30">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
        </svg>
        <p class="text-sm">Nenhum orçamento encontrado nos últimos 365 dias.</p>
      </div>

      <!-- Lista de orçamentos -->
      <div *ngFor="let group of orcamentoGroups" class="rounded-xl overflow-hidden" style="border: 1px solid var(--flua-borda)">

        <!-- Cabeçalho do orçamento -->
        <div class="px-4 py-3 flex items-center justify-between"
          style="background-color: var(--brand-surface); border-bottom: 1px solid var(--flua-borda)">
          <div>
            <p class="text-sm font-semibold" style="color: var(--tx)">
              Orçamento #{{ group.nrSequenciaOrcamento }}
            </p>
            <p class="text-xs mt-0.5" style="color: var(--tx-2)">
              {{ group.dtOrcamento | date:'dd/MM/yyyy' }}
            </p>
          </div>
          <div class="text-right">
            <p class="text-sm font-bold" style="color: var(--brand-primary)">
              {{ formatCurrency(isParticular ? group.totalVista : group.totalCartao) }}
            </p>
            <!-- Todos checkbox -->
            <label class="flex items-center gap-1 text-xs cursor-pointer" style="color: var(--tx-2)">
              <input type="checkbox" [checked]="todosSelecionados(group)" (change)="toggleTodosOrcamento(group)"
                class="accent-[var(--brand-primary)]" />
              Todos
            </label>
          </div>
        </div>

        <!-- Procedimentos do orçamento -->
        <div class="divide-y" style="border-color: #F4F1EA">
          <div *ngFor="let proc of group.procedimentos" class="px-4 py-2.5 flex items-center gap-3"
            style="background-color: var(--cartao)">
            <input type="checkbox" [(ngModel)]="proc.selecionado" class="accent-[var(--brand-primary)] flex-shrink-0" />
            <div class="flex-1 min-w-0">
              <p class="text-xs font-medium truncate" style="color: var(--tx)">{{ proc.dsProcedimento }}</p>
              <p class="text-xs" style="color: var(--tx-2)">Qtd: {{ proc.qtProcedimento }}</p>
            </div>
            <p class="text-xs font-semibold flex-shrink-0" style="color: var(--brand-secondary)">
              {{ formatCurrency(isParticular ? proc.vlVista : proc.vlCartao) }}
            </p>
          </div>
        </div>

      </div>
    </div>

    <!-- Footer — botão único -->
    <div class="px-5 py-4 flex items-center justify-between gap-3"
      style="border-top: 1px solid var(--flua-borda); background-color: var(--brand-surface); flex-shrink: 0">
      <span class="text-xs" style="color: var(--tx-2)">
        {{ totalSelecionadosOrcamento }} procedimento(s) selecionado(s)
      </span>
      <button (click)="inserirSelecionados()" [disabled]="totalSelecionadosOrcamento === 0 || isInserindoOrcamento"
        class="px-5 py-2 rounded-lg text-white text-sm font-semibold flex items-center gap-2 transition-opacity"
        [style.backgroundColor]="totalSelecionadosOrcamento === 0 || isInserindoOrcamento ? '#D6CFC2' : 'var(--brand-primary)'"
        [style.cursor]="totalSelecionadosOrcamento === 0 || isInserindoOrcamento ? 'not-allowed' : 'pointer'"
        onmouseover="if(!this.disabled) this.style.backgroundColor='var(--brand-ink)'"
        onmouseout="if(!this.disabled) this.style.backgroundColor='var(--brand-primary)'">
        <div *ngIf="isInserindoOrcamento" class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
        <svg *ngIf="!isInserindoOrcamento" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke-width="2" stroke="currentColor" class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
        </svg>
        {{ isInserindoOrcamento ? 'Adicionando...' : 'Inserir Selecionados' }}
      </button>
    </div>
  </div>
</div>

<!-- ── Modal: Pular Pagamento — Alterar Status ──────────────────── -->
<div *ngIf="showPularPagamentoModal" class="fixed inset-0 z-50 flex items-center justify-center"
  style="background-color: rgba(0,0,0,0.5)">
  <div class="rounded-2xl shadow-xl w-full max-w-md mx-4 p-6 text-center" style="background-color: var(--cartao)"
    (click)="$event.stopPropagation()">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
      stroke="var(--brand-primary)" class="size-12 mx-auto mb-3">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25Z" />
    </svg>
    <h3 class="font-semibold text-base mb-2" style="color: var(--tx)">Alterar status da agenda?</h3>
    <p class="text-sm mb-5" style="color: var(--tx-2)">
      Deseja marcar a agenda como <strong>Aguardando Consulta</strong> agora que o pagamento foi pulado?
    </p>
    <div class="flex justify-center gap-3">
      <button (click)="confirmarPularPagamento(true)"
        class="px-5 py-2 rounded-lg text-sm font-semibold text-white flex items-center gap-1.5"
        style="background-color: var(--brand-primary)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
          class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
        </svg>
        Sim, alterar
      </button>
      <button (click)="confirmarPularPagamento(false)"
        class="px-5 py-2 rounded-lg text-sm font-semibold flex items-center gap-1.5"
        style="border: 1px solid var(--flua-borda); color: var(--tx-2)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
          class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
        Não
      </button>
    </div>
  </div>
</div>

<!-- ── Modal: Atendimento Duplicado ──────────────────────────────── -->
<!-- ════════════════════════════════════════════════════════════
     MODAL — COBRAR NA MAQUINETA
     ════════════════════════════════════════════════════════════ -->
<div *ngIf="showMaquinetaModal" class="fixed inset-0 z-50 flex items-center justify-center"
  style="background-color: rgba(0,0,0,0.5)">
  <div class="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 overflow-hidden" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="px-5 py-4 flex items-center justify-between" style="background-color: var(--brand-secondary)">
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white"
          class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
        </svg>
        <span class="font-semibold text-sm text-white">Cobrar na Maquineta</span>
      </div>
      <button (click)="fecharMaquinetaModal()" style="color: white" class="p-1">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
          class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Aguardando Maquineta -->
    <div *ngIf="aguardandoMaquineta" class="px-5 py-8 text-center">
      <div class="animate-pulse mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
          stroke="var(--ok)" class="size-16 mx-auto">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
        </svg>
      </div>
      <p class="font-semibold text-sm" style="color: var(--tx)">Aguardando na maquineta...</p>
      <p class="text-xs mt-1" style="color: var(--tx-2)">Peça ao cliente para inserir ou aproximar o cartão</p>
      <button (click)="finalizarMaquineta()" class="mt-6 w-full py-2.5 rounded-lg text-sm font-semibold text-white"
        style="background-color: var(--brand-secondary)" onmouseover="this.style.filter='brightness(0.9)'"
        onmouseout="this.style.filter=''">
        Pagamento Concluído — Fechar
      </button>
    </div>

    <!-- Formulário -->
    <div *ngIf="!aguardandoMaquineta" class="px-5 py-5 space-y-4">

      <!-- Valor -->
      <div class="rounded-lg p-3 text-center" style="background-color: #f0fdf4; border: 1px solid #bbf7d0">
        <p class="text-xs mb-1" style="color: var(--tx-2)">Valor a cobrar</p>
        <div class="flex items-center justify-center gap-1">
          <span class="text-lg font-bold" style="color: var(--brand-secondary)">R$</span>
          <input type="number" [(ngModel)]="maquinetaValor" (ngModelChange)="onMaquinetaValorChange()" min="0.01"
            [max]="dadosPagamento?.vlTotalConta || 0" step="0.01"
            class="text-2xl font-bold text-center border-b-2 bg-transparent outline-none"
            style="color: var(--brand-secondary); border-color: #bbf7d0; width: 160px"
            (focus)="$any($event.target).select()" />
        </div>
        <p *ngIf="maquinetaValor < (dadosPagamento?.vlTotalConta || 0)" class="text-[10px] mt-1" style="color: var(--tx-2)">
          Total da conta: {{ formatCurrency(dadosPagamento?.vlTotalConta || 0) }} — Restante: {{
          formatCurrency((dadosPagamento?.vlTotalConta || 0) - maquinetaValor) }}
        </p>
      </div>

      <!-- Método de Pagamento -->
      <div>
        <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Forma de Pagamento</label>
        <div class="flex gap-2">
          <button (click)="maquinetaMetodo = 1; maquinetaParcelas = 1"
            class="flex-1 py-2 rounded-lg text-xs font-semibold text-center"
            [style.backgroundColor]="maquinetaMetodo === 1 ? 'var(--brand-secondary)' : 'white'"
            [style.color]="maquinetaMetodo === 1 ? 'white' : '#4A5D6B'"
            [style.border]="'1px solid ' + (maquinetaMetodo === 1 ? 'var(--brand-secondary)' : '#E5DFD4')">
            Crédito
          </button>
          <button (click)="maquinetaMetodo = 2; maquinetaParcelas = 1"
            class="flex-1 py-2 rounded-lg text-xs font-semibold text-center"
            [style.backgroundColor]="maquinetaMetodo === 2 ? 'var(--brand-secondary)' : 'white'"
            [style.color]="maquinetaMetodo === 2 ? 'white' : '#4A5D6B'"
            [style.border]="'1px solid ' + (maquinetaMetodo === 2 ? 'var(--brand-secondary)' : '#E5DFD4')">
            Débito/Pix
          </button>
        </div>
      </div>

      <!-- Parcelas (só crédito) -->
      <div *ngIf="maquinetaMetodo === 1">
        <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Parcelas</label>
        <div class="grid grid-cols-5 gap-1">
          <button *ngFor="let p of parcelasDisponiveis" (click)="maquinetaParcelas = p"
            class="py-1.5 rounded text-xs font-semibold text-center"
            [style.backgroundColor]="maquinetaParcelas === p ? 'var(--brand-secondary)' : 'white'"
            [style.color]="maquinetaParcelas === p ? 'white' : '#4A5D6B'"
            [style.border]="'1px solid ' + (maquinetaParcelas === p ? 'var(--brand-secondary)' : '#E5DFD4')">
            {{ p }}x
          </button>
        </div>
        <p *ngIf="dadosPagamento && maquinetaParcelas > 1" class="text-[10px] mt-1" style="color: var(--tx-2)">
          {{ maquinetaParcelas }}x de {{ formatCurrency((maquinetaValor || 0) / maquinetaParcelas) }}
        </p>
        <p *ngIf="parcelasDisponiveis.length === 1" class="text-[10px] mt-1" style="color: var(--tx-2)">
          Parcelamento mínimo: {{ formatCurrency(parcelaMinimaAtual) }} por parcela
        </p>
      </div>

      <!-- Terminal -->
      <div>
        <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Terminal (Maquineta)</label>
        <div class="flex gap-2 mb-2">
          <button (click)="selecionarTerminalTipo('V240mPlus')" class="px-3 py-1.5 rounded text-xs font-semibold"
            [style.backgroundColor]="maquinetaTerminalTipo === 'V240mPlus' ? 'var(--brand-secondary)' : 'white'"
            [style.color]="maquinetaTerminalTipo === 'V240mPlus' ? 'white' : '#4A5D6B'"
            [style.border]="'1px solid ' + (maquinetaTerminalTipo === 'V240mPlus' ? 'var(--brand-secondary)' : '#E5DFD4')">
            V240mPlus
          </button>
          <button (click)="selecionarTerminalTipo('P400Plus')" class="px-3 py-1.5 rounded text-xs font-semibold"
            [style.backgroundColor]="maquinetaTerminalTipo === 'P400Plus' ? 'var(--brand-secondary)' : 'white'"
            [style.color]="maquinetaTerminalTipo === 'P400Plus' ? 'white' : '#4A5D6B'"
            [style.border]="'1px solid ' + (maquinetaTerminalTipo === 'P400Plus' ? 'var(--brand-secondary)' : '#E5DFD4')">
            P400Plus
          </button>
          <button (click)="selecionarTerminalTipo('S1F2')" class="px-3 py-1.5 rounded text-xs font-semibold"
            [style.backgroundColor]="maquinetaTerminalTipo === 'S1F2' ? 'var(--brand-secondary)' : 'white'"
            [style.color]="maquinetaTerminalTipo === 'S1F2' ? 'white' : '#4A5D6B'"
            [style.border]="'1px solid ' + (maquinetaTerminalTipo === 'S1F2' ? 'var(--brand-secondary)' : '#E5DFD4')">
            S1F2
          </button>
        </div>
        <div class="relative">
          <div class="flex items-center rounded-lg border overflow-hidden" style="border-color: var(--flua-borda)">
            <span class="px-2 py-2 text-xs bg-gray-50" style="color: var(--tx-2); border-right: 1px solid var(--flua-borda)">{{
              maquinetaTerminalTipo }}-</span>
            <input type="text" [(ngModel)]="maquinetaTerminalNumero" (input)="filtrarTerminais()"
              (focus)="filtrarTerminais()" placeholder="Digite os últimos dígitos..." class="flex-1 text-xs px-2 py-2"
              style="outline: none; color: var(--tx)" />
          </div>
          <div *ngIf="showTerminalDropdown"
            class="absolute z-10 left-0 right-0 mt-1 rounded-lg shadow-lg overflow-hidden"
            style="background-color: var(--cartao); border: 1px solid var(--flua-borda); max-height: 180px; overflow-y: auto">
            <div *ngFor="let t of maquinetaTerminaisFiltrados" (mousedown)="selecionarTerminal(t)"
              class="px-3 py-2 text-xs cursor-pointer hover:bg-gray-100 flex justify-between" style="color: var(--tx)">
              <span>{{ t.tipo }}-<strong>{{ t.numero }}</strong></span>
              <span class="text-[10px]" style="color: var(--tx-2)">{{ t.loja }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer (só se não está aguardando) -->
    <div *ngIf="!aguardandoMaquineta" class="px-5 py-4 flex justify-end gap-2" style="border-top: 1px solid var(--flua-borda)">
      <button (click)="fecharMaquinetaModal()" class="px-4 py-2 rounded-lg text-xs font-semibold"
        style="border: 1px solid var(--flua-borda); color: var(--tx-2)">
        Cancelar
      </button>
      <button (click)="enviarMaquineta()" [disabled]="isEnviandoMaquineta || !maquinetaTerminalFull"
        class="px-5 py-2 rounded-lg text-xs font-semibold text-white flex items-center gap-1.5"
        style="background-color: var(--brand-secondary)"
        [style.opacity]="isEnviandoMaquineta || !maquinetaTerminalFull ? 0.5 : 1"
        [style.cursor]="isEnviandoMaquineta || !maquinetaTerminalFull ? 'not-allowed' : 'pointer'">
        <div *ngIf="isEnviandoMaquineta" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
        {{ isEnviandoMaquineta ? 'Enviando...' : 'Enviar para Maquineta' }}
      </button>
    </div>
  </div>
</div>

<app-pagamento-especie-modal
  [aberto]="showCaixaModal"
  [clinicId]="clinicId"
  [userName]="userName"
  [personId]="selectedPassword?.personId ?? null"
  [valorConta]="dadosPagamento?.vlSaldo ?? 0"
  [valorSugerido]="dadosPagamento?.vlSaldo ?? dadosPagamento?.vlTotalConta ?? 0"
  (fechar)="showCaixaModal = false"
  (registrado)="onEspecieRegistrado()"></app-pagamento-especie-modal>

<!-- ════════════════════════════════════════════════════════════
     MODAL — CUPONS DE DESCONTO
     ════════════════════════════════════════════════════════════ -->
<div *ngIf="showCupomModal" class="fixed inset-0 z-50 flex items-center justify-center"
  style="background-color: rgba(0,0,0,0.5)">
  <div class="bg-white rounded-2xl shadow-xl w-full max-w-md max-h-[80vh] flex flex-col"
    (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="px-5 py-4 flex items-center justify-between" style="border-bottom: 1px solid var(--flua-borda); flex-shrink: 0">
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#f59e0b"
          class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z" />
        </svg>
        <span class="font-semibold text-sm" style="color: var(--tx)">Cupons Disponíveis</span>
      </div>
      <button (click)="fecharCupomModal()" class="p-1 rounded-lg hover:bg-gray-100">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#4A5D6B"
          class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="px-5 py-4 overflow-y-auto flex-1 space-y-3" style="min-height: 100px">

      <!-- Loading -->
      <div *ngIf="isLoadingCupons" class="flex justify-center py-6">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2" style="border-color: #f59e0b"></div>
      </div>

      <!-- Vazio -->
      <div *ngIf="!isLoadingCupons && cuponsDisponiveis.length === 0" class="text-center py-6">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="#E5DFD4"
          class="size-10 mx-auto mb-2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z" />
        </svg>
        <p class="text-sm" style="color: var(--tx-2)">Nenhum cupom disponível para este paciente.</p>
      </div>

      <!-- Feedback (sucesso ou erro) -->
      <div *ngIf="cupomMensagem" class="rounded-lg px-4 py-3 text-sm flex items-start gap-2"
        [style.backgroundColor]="cupomMensagemTipo === 'sucesso' ? '#f0fdf4' : '#fef2f2'"
        [style.border]="cupomMensagemTipo === 'sucesso' ? '1px solid #bbf7d0' : '1px solid #fecaca'"
        [style.color]="cupomMensagemTipo === 'sucesso' ? '#166534' : '#991b1b'">
        <svg *ngIf="cupomMensagemTipo === 'sucesso'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke-width="2" stroke="#16a34a" class="size-4 flex-shrink-0 mt-0.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
        </svg>
        <svg *ngIf="cupomMensagemTipo === 'erro'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke-width="2" stroke="#dc2626" class="size-4 flex-shrink-0 mt-0.5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
        </svg>
        <span>{{ cupomMensagem }}</span>
      </div>

      <!-- Lista de cupons -->
      <div *ngFor="let cupom of cuponsDisponiveis" class="rounded-xl p-4"
        style="border: 1px solid var(--flua-borda); background-color: var(--cartao)">
        <div class="flex items-start justify-between">
          <div class="flex-1">
            <p class="text-sm font-semibold" style="color: var(--tx)">{{ cupom.descCupom }}</p>
            <p *ngIf="cupom.dtExpiracao" class="text-xs mt-0.5" style="color: var(--tx-2)">
              Válido até {{ cupom.dtExpiracao }}
            </p>
          </div>
          <div class="text-right">
            <p class="text-lg font-bold" style="color: #f59e0b">{{ formatCupomValor(cupom) }}</p>
            <p class="text-[10px]" style="color: var(--tx-2)">de desconto</p>
          </div>
        </div>
        <button (click)="aplicarCupom(cupom)" [disabled]="isAplicandoCupom"
          class="mt-3 w-full py-2 rounded-lg text-xs font-semibold text-white flex items-center justify-center gap-1.5"
          [style.backgroundColor]="isAplicandoCupom ? '#D6CFC2' : 'var(--brand-primary)'"
          [style.cursor]="isAplicandoCupom ? 'not-allowed' : 'pointer'"
          onmouseover="if(!this.disabled) this.style.backgroundColor='var(--brand-ink)'"
          onmouseout="if(!this.disabled) this.style.backgroundColor='var(--brand-primary)'">
          <div *ngIf="isAplicandoCupom" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
          <svg *ngIf="!isAplicandoCupom" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="2" stroke="currentColor" class="size-3.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
          </svg>
          {{ isAplicandoCupom ? 'Aplicando...' : 'Aplicar Cupom' }}
        </button>
      </div>

    </div>
  </div>
</div>

<!-- ════════════════════════════════════════════════════════════
     MODAL — VINCULAR ADIANTAMENTO
     ════════════════════════════════════════════════════════════ -->
<div *ngIf="showVincularModal" class="fixed inset-0 z-[60] flex items-center justify-center"
  style="background-color: rgba(0,0,0,0.5)">
  <div class="bg-white rounded-2xl shadow-xl w-full max-w-lg mx-4 max-h-[85vh] flex flex-col overflow-hidden"
    (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="px-5 py-4 flex items-center justify-between" style="flex-shrink: 0; border-bottom: 1px solid var(--flua-borda)">
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="var(--brand-secondary)" class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
        </svg>
        <span class="font-semibold text-sm" style="color: var(--tx)">Vincular Adiantamento</span>
      </div>
      <div class="flex items-center gap-1">
        <button (click)="atualizarAdiantamentos()" [disabled]="atualizandoAdiantamentos || buscaAdiantamentos.bloqueioManual > 0" title="Buscar os adiantamentos de novo"
                class="px-2.5 py-1 rounded-lg text-xs font-semibold flex items-center gap-1"
                style="border: 1px solid var(--brand-secondary); color: var(--brand-secondary)"
                [class.animate-pulse]="buscaAdiantamentos.encerrada && buscaAdiantamentos.bloqueioManual === 0"
                [style.boxShadow]="buscaAdiantamentos.encerrada ? '0 0 0 3px rgba(0,172,112,.25)' : null"
                [style.opacity]="atualizandoAdiantamentos || buscaAdiantamentos.bloqueioManual > 0 ? 0.5 : 1"
                [style.cursor]="atualizandoAdiantamentos || buscaAdiantamentos.bloqueioManual > 0 ? 'not-allowed' : 'pointer'">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
               stroke="currentColor" class="size-3.5" [class.animate-spin]="atualizandoAdiantamentos">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
          </svg>
          {{ buscaAdiantamentos.bloqueioManual > 0 ? 'Aguarde ' + buscaAdiantamentos.bloqueioManual + 's' : 'Atualizar' }}
        </button>
        <button (click)="fecharVincularModal()" class="p-1 rounded-lg hover:bg-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#4A5D6B"
            class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Info da conta -->
    <div class="px-5 py-3" style="background-color: var(--brand-surface); border-bottom: 1px solid var(--flua-borda); flex-shrink: 0">
      <div class="flex justify-between text-sm">
        <span style="color: var(--tx-2)">Conta: <strong style="color: var(--tx)">{{ dadosPagamento?.nrInternoConta
            }}</strong></span>
        <span style="color: var(--tx-2)">Saldo Pendente: <strong
            [style.color]="(dadosPagamento?.vlSaldo ?? 0) <= 0 ? '#00AC70' : '#dc2626'">{{ (dadosPagamento?.vlSaldo ??
            0) <= 0 ? '✓ Quitado' : formatCurrency(dadosPagamento?.vlSaldo ?? 0) }}</strong></span>
      </div>
    </div>

    <!-- Status da busca automática -->
    <div *ngIf="(buscaAdiantamentos.procurando || buscaAdiantamentos.encerrada || adiantamentosNovos.size > 0)" class="px-5 py-2 flex items-center gap-2 text-xs"
         style="flex-shrink: 0; border-bottom: 1px solid var(--flua-borda)"
         [style.backgroundColor]="adiantamentosNovos.size > 0 ? '#f0fdf4' : buscaAdiantamentos.encerrada ? '#FFF8E1' : 'transparent'">
      <span *ngIf="adiantamentosNovos.size > 0; else faixaBusca" class="font-semibold" style="color: #059669">
        ✓ {{ adiantamentosNovos.size }} {{ adiantamentosNovos.size > 1 ? 'adiantamentos novos encontrados' : 'adiantamento novo encontrado' }}
      </span>
      <ng-template #faixaBusca>
        <ng-container *ngIf="buscaAdiantamentos.procurando">
          <span class="relative flex h-2 w-2">
            <span class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75" style="background-color: #00AC70"></span>
            <span class="relative inline-flex rounded-full h-2 w-2" style="background-color: #00AC70"></span>
          </span>
          <span style="color: var(--tx-2)">Atualizando automaticamente · próxima busca em {{ buscaAdiantamentos.segundosParaProxima }}s</span>
        </ng-container>
        <ng-container *ngIf="buscaAdiantamentos.encerrada">
          <span style="color: #8A6D00">Não encontrou o adiantamento do pagamento?</span>
          <button (click)="atualizarAdiantamentos()" [disabled]="buscaAdiantamentos.bloqueioManual > 0" class="font-semibold underline"
                  style="color: var(--brand-secondary)">Atualizar</button>
        </ng-container>
      </ng-template>
    </div>

    <!-- Body -->
    <div class="px-5 py-4 overflow-y-auto flex-1">
      <p class="text-xs font-semibold mb-3" style="color: var(--tx)">Selecione o adiantamento:</p>

      <div *ngIf="isLoadingAdiantamentos" class="flex justify-center py-6">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2" style="border-color: var(--brand-secondary)"></div>
      </div>

      <div *ngIf="!isLoadingAdiantamentos && adiantamentosDisponiveis.length === 0" class="text-center py-6">
        <ng-container *ngIf="buscaAdiantamentos.procurando; else semAdiantamento">
          <div class="animate-spin rounded-full h-5 w-5 border-b-2 mx-auto mb-2" style="border-color: var(--brand-secondary)"></div>
          <p class="text-sm" style="color: var(--tx-2)">Procurando adiantamentos…</p>
          <p class="text-xs mt-1" style="color: var(--tx-2)">O pagamento pode levar alguns segundos para aparecer.</p>
        </ng-container>
        <ng-template #semAdiantamento>
          <p class="text-sm" style="color: var(--tx-2)">Nenhum adiantamento disponível para este paciente.</p>
          <button (click)="atualizarAdiantamentos()" [disabled]="buscaAdiantamentos.bloqueioManual > 0" class="mt-2 text-xs font-semibold underline" style="color: var(--brand-secondary)">Procurar de novo</button>
        </ng-template>
      </div>

      <div *ngIf="!isLoadingAdiantamentos" class="space-y-3">
        <div *ngFor="let adian of adiantamentosDisponiveis" (click)="toggleAdiantamento(adian.nrAdiantamento)"
          class="rounded-xl p-4 cursor-pointer transition-all"
          [style.boxShadow]="adiantamentosNovos.has(adian.nrAdiantamento) ? '0 0 0 3px rgba(0,172,112,.35)' : null"
          [style.border]="isAdiantamentoSelecionado(adian.nrAdiantamento) ? '2px solid var(--brand-secondary)' : '1px solid #E5DFD4'"
          [style.backgroundColor]="isAdiantamentoSelecionado(adian.nrAdiantamento) ? '#f0fdf4' : 'white'">
          <div class="flex items-start gap-3">
            <input type="checkbox" [checked]="isAdiantamentoSelecionado(adian.nrAdiantamento)"
              class="accent-[var(--brand-secondary)] mt-0.5 flex-shrink-0 pointer-events-none" />
            <div class="flex-1 min-w-0">
              <p class="text-xs" style="color: var(--tx)">{{ adian.dsAdiantamento }}
                <span *ngIf="adiantamentosNovos.has(adian.nrAdiantamento)" class="ml-1 px-1.5 py-0.5 rounded text-[10px] font-bold text-white"
                      style="background-color: var(--brand-secondary)">Novo</span>
              </p>
              <p class="text-sm font-bold mt-1" style="color: var(--brand-secondary)">
                Saldo disponível: {{ formatCurrency(adian.vlSaldo) }}
              </p>
              <p class="text-xs mt-0.5" style="color: var(--tx-2)">
                → Saldo: {{ formatCurrency(adian.vlSaldo) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="totalAdiantamentosSelecionados > 0" class="mt-4 rounded-lg p-3 text-sm"
        style="background-color: #f0fdf4; border: 1px solid #bbf7d0">
        <div class="flex justify-between">
          <span style="color: var(--tx-2)">Total selecionado ({{ totalAdiantamentosSelecionados }})</span>
          <span class="font-bold" style="color: var(--brand-secondary)">{{
            formatCurrency(valorAdiantamentosSelecionados) }}</span>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-5 py-4 flex justify-end gap-2" style="border-top: 1px solid var(--flua-borda); flex-shrink: 0">
      <button (click)="fecharVincularModal()" class="px-4 py-2 rounded-lg text-xs font-semibold"
        style="border: 1px solid var(--flua-borda); color: var(--tx-2)">
        Cancelar
      </button>
      <button (click)="confirmarVinculacao()" [disabled]="isVinculando || totalAdiantamentosSelecionados === 0"
        class="px-5 py-2 rounded-lg text-xs font-semibold text-white flex items-center gap-1.5"
        style="background-color: var(--brand-secondary)"
        [style.opacity]="isVinculando || totalAdiantamentosSelecionados === 0 ? 0.5 : 1"
        [style.cursor]="isVinculando || totalAdiantamentosSelecionados === 0 ? 'not-allowed' : 'pointer'">
        <div *ngIf="isVinculando" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
        <svg *ngIf="!isVinculando" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
          stroke="currentColor" class="size-3.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
        </svg>
        {{ isVinculando ? vincularProgresso : 'Confirmar' }}
      </button>
    </div>
  </div>
</div>

<div *ngIf="showDuplicadoModal" class="fixed inset-0 z-[60] flex items-center justify-center"
  style="background-color: rgba(0, 0, 0, 0.6)">
  <div class="rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden" style="background-color: var(--brand-surface)">

    <!-- Header -->
    <div class="px-6 py-5 flex items-center gap-3" style="background-color: var(--thead)">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#facc15"
        class="size-7 flex-shrink-0">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
      </svg>
      <span class="text-white font-semibold text-base">Atendimento Duplicado</span>
    </div>

    <!-- Body -->
    <div class="px-6 py-5">
      <p class="text-sm leading-relaxed" style="color: var(--tx)">
        Já existe o atendimento
        <strong style="color: var(--brand-primary)">N° {{ atendimentoDuplicado?.nrAtendimento }}</strong>
        aberto para este paciente, neste estabelecimento e com este médico hoje
        <span *ngIf="atendimentoDuplicado?.dtAtendimento">({{ atendimentoDuplicado?.dtAtendimento }})</span>.
      </p>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 flex justify-end gap-3" style="border-top: 1px solid var(--flua-borda)">
      <button (click)="fecharDuplicadoModal()"
        class="px-5 py-2 rounded-lg text-white text-sm font-semibold transition-opacity"
        style="background-color: #8c8c8c" onmouseover="this.style.backgroundColor='#6e6e6e'"
        onmouseout="this.style.backgroundColor='#8c8c8c'">
        Cancelar
      </button>
      <button (click)="confirmarCriarMesmoAssim()"
        class="px-5 py-2 rounded-lg text-white text-sm font-semibold transition-opacity"
        style="background-color: #d34747" onmouseover="this.style.backgroundColor='#b83232'"
        onmouseout="this.style.backgroundColor='#d34747'">
        Abrir mesmo assim
      </button>
    </div>
  </div>
</div>

<app-responsavel-modal
  [aberto]="showModalResponsavel"
  [cdPessoaFisica]="patientDetails?.id ?? null"
  [cpfPaciente]="selectedPassword?.cpf ?? null"
  [obrigatorio]="ehMenorDeIdade"
  (fechar)="showModalResponsavel = false"
  (carregado)="onResponsavelCarregado($event)"
  (salvo)="onResponsavelSalvo($event)">
</app-responsavel-modal>

<!-- ══════════════════ MODAL AVALIAÇÃO ODONTOLÓGICA GRATUITA ══════════════════ -->
<div *ngIf="showAvaliacaoOdontoModal" class="fixed inset-0 z-[55] flex items-center justify-center p-4"
  style="background-color: rgba(0,0,0,0.6)">
  <div class="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col"
    style="border: 1px solid var(--flua-borda); max-height: 90vh">

    <!-- Cabeçalho -->
    <div class="px-5 py-4 flex items-center gap-3 flex-shrink-0" style="background-color: var(--thead)">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="white"
        class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z" />
      </svg>
      <h3 class="text-white font-semibold text-base">Avaliação Odontológica Gratuita</h3>
    </div>

    <!-- Corpo: pergunta inicial -->
    <div *ngIf="!modoJustificativaOdonto && !avaliacaoOdontoSucesso"
      class="px-5 py-5 flex flex-col gap-3 overflow-y-auto flex-1">
      <p class="text-sm" style="color: var(--tx)">
        O paciente deseja uma <strong>avaliação odontológica gratuita</strong> hoje?
      </p>

      <!-- Seleção de agenda -->
      <ng-container *ngIf="agendasOdonto.length > 0">
        <p class="text-xs font-medium" style="color: var(--tx-2)">Selecione o dentista:</p>
        <div *ngFor="let ag of agendasOdonto" (click)="agendaOdontoSelecionada = ag.cdAgenda"
          class="flex items-center gap-3 p-3 rounded-lg cursor-pointer border"
          [style.border-color]="agendaOdontoSelecionada === ag.cdAgenda ? 'var(--brand-primary)' : '#E5DFD4'"
          [style.background-color]="agendaOdontoSelecionada === ag.cdAgenda ? 'var(--brand-tint)' : 'white'">
          <!-- Radio -->
          <div class="w-4 h-4 rounded-full border-2 flex-shrink-0 flex items-center justify-center"
            [style.border-color]="agendaOdontoSelecionada === ag.cdAgenda ? 'var(--brand-primary)' : '#E5DFD4'">
            <div *ngIf="agendaOdontoSelecionada === ag.cdAgenda" class="w-2 h-2 rounded-full"
              style="background-color: var(--brand-primary)"></div>
          </div>
          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium truncate" style="color: var(--tx)">{{ ag.nmMedico }}</p>
            <p class="text-xs truncate" style="color: var(--tx-2)">
              {{ ag.qtAC }} {{ ag.qtAC === 1 ? 'paciente agendado' : 'pacientes agendados' }} hoje
            </p>
          </div>
        </div>
      </ng-container>

      <p *ngIf="avaliacaoOdontoErro" class="text-xs" style="color: #d34747">{{ avaliacaoOdontoErro }}</p>
    </div>

    <!-- Corpo: justificativa -->
    <div *ngIf="modoJustificativaOdonto && !avaliacaoOdontoSucesso" class="px-5 py-5 flex flex-col gap-3">
      <p class="text-sm" style="color: var(--tx)">
        Informe o motivo pelo qual o paciente recusou a avaliação:
      </p>
      <textarea [(ngModel)]="motivoRecusaOdonto" rows="3" placeholder="Ex.: Paciente não tem interesse no momento."
        class="w-full rounded-lg border px-3 py-2 text-sm outline-none resize-none"
        style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)"></textarea>
      <p *ngIf="avaliacaoOdontoErro" class="text-xs" style="color: #d34747">{{ avaliacaoOdontoErro }}</p>
    </div>

    <!-- Corpo: sucesso -->
    <div *ngIf="avaliacaoOdontoSucesso" class="px-5 py-5 flex flex-col gap-3 items-center text-center">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#00AC70"
        class="size-10">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
      </svg>
      <p class="text-sm font-semibold" style="color: var(--ok)">{{ avaliacaoOdontoSucesso }}</p>
      <ng-container *ngIf="odontoResult as r">
        <div *ngIf="r.nrAtendimento" class="flex gap-3 mt-1">
          <span class="inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-medium"
            style="background-color: #e8f5e9; color: #2e7d32">
            Atend: {{ r.nrAtendimento }}
          </span>
          <span *ngIf="r.nrPrescricao" class="inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-medium"
            style="background-color: #e8f5e9; color: #2e7d32">
            Presc: {{ r.nrPrescricao }}
          </span>
        </div>
      </ng-container>
    </div>

    <!-- Rodapé: pergunta inicial -->
    <div *ngIf="!modoJustificativaOdonto && !avaliacaoOdontoSucesso"
      class="px-5 py-3 flex items-center justify-end gap-2 border-t flex-shrink-0"
      style="border-color: var(--flua-borda); background-color: var(--brand-surface)">
      <button type="button" (click)="recusarAvaliacaoOdonto()" class="px-4 py-2 rounded-lg text-sm font-semibold"
        style="background-color: #8c8c8c; color: white">
        Não
      </button>
      <button type="button" (click)="aceitarAvaliacaoOdonto()" [disabled]="isAgendandoOdonto"
        class="px-5 py-2 rounded-lg text-sm font-semibold text-white" style="background-color: var(--brand-secondary)">
        {{ isAgendandoOdonto ? 'Abrindo atendimento...' : 'Sim, agendar' }}
      </button>
    </div>

    <!-- Rodapé: justificativa -->
    <div *ngIf="modoJustificativaOdonto && !avaliacaoOdontoSucesso"
      class="px-5 py-3 flex items-center justify-end gap-2 border-t"
      style="border-color: var(--flua-borda); background-color: var(--brand-surface)">
      <button type="button" (click)="modoJustificativaOdonto = false; avaliacaoOdontoErro = ''"
        class="px-4 py-2 rounded-lg text-sm font-semibold" style="background-color: #8c8c8c; color: white">
        Voltar
      </button>
      <button type="button" (click)="confirmarRecusaOdonto()"
        class="px-5 py-2 rounded-lg text-sm font-semibold text-white" style="background-color: var(--brand-primary)">
        Confirmar
      </button>
    </div>

    <!-- Rodapé: sucesso -->
    <div *ngIf="avaliacaoOdontoSucesso" class="px-5 py-3 flex items-center justify-end gap-2 border-t"
      style="border-color: var(--flua-borda); background-color: var(--brand-surface)">
      <button type="button" (click)="fecharAvaliacaoOdontoModal()"
        class="px-5 py-2 rounded-lg text-sm font-semibold text-white" style="background-color: var(--brand-secondary)">
        Continuar
      </button>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════ -->
<!-- Modal Atendimento em clínica parceira                        -->
<!-- ═══════════════════════════════════════════════════════════ -->
<div *ngIf="showParceirasModal" class="fixed inset-0 z-50 flex items-center justify-center p-4"
  style="background-color: rgba(0,0,0,0.5)">
  <div class="w-full max-w-md rounded-2xl shadow-xl overflow-hidden flex flex-col"
    style="background-color: var(--cartao); max-height: 90vh">
    <div class="px-5 py-4 flex items-center justify-between"
      style="border-bottom: 1px solid var(--flua-borda); background-color: var(--brand-surface)">
      <div>
        <p class="font-semibold text-sm" style="color: var(--tx)">Atendimento em clínica parceira</p>
        <p class="text-xs mt-0.5" style="color: var(--tx-2)">Sem agendamento · exames</p>
      </div>
      <button (click)="showParceirasModal = false" class="p-1 rounded" style="color: var(--tx-2)" aria-label="Fechar">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="px-5 pt-4 pb-2">
      <div class="flex items-center gap-2 px-3 py-2 rounded-lg border"
        style="border-color: var(--flua-borda); background-color: var(--cartao)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="size-4 flex-shrink-0" style="color: var(--tx-3)">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
        <input type="text" [(ngModel)]="filtroParceira" placeholder="Filtrar clínica..."
          class="flex-1 bg-transparent text-sm outline-none" style="color: var(--tx)" />
      </div>
    </div>

    <div class="flex-1 overflow-y-auto">
      <p *ngIf="parceirasFiltradas.length === 0" class="text-sm text-center py-10" style="color: var(--tx-2)">
        Nenhuma clínica parceira encontrada.
      </p>
      <div class="divide-y" style="border-color: var(--flua-borda)">
        <button *ngFor="let c of parceirasFiltradas" type="button" (click)="escolherParceira(c)"
          class="w-full text-left px-5 py-3 flex items-center gap-3 transition-colors"
          onmouseover="this.style.backgroundColor='var(--brand-surface)'" onmouseout="this.style.backgroundColor='transparent'">
          <div class="flex-1 min-w-0">
            <p class="font-semibold text-sm truncate" style="color: var(--tx)">{{ c.nmClinica || c.dsAgenda }}</p>
            <p *ngIf="c.dsAgenda && c.dsAgenda !== c.nmClinica" class="text-xs mt-0.5 truncate" style="color: var(--tx-2)">{{ c.dsAgenda }}</p>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="size-4 flex-shrink-0" style="color: var(--tx-3)">
            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
          </svg>
        </button>
      </div>
    </div>

    <div class="px-5 py-3 flex justify-end" style="border-top: 1px solid var(--flua-borda); background-color: var(--brand-surface)">
      <button type="button" (click)="showParceirasModal = false" class="px-5 py-2 rounded-lg text-sm font-medium"
        style="border: 1px solid var(--flua-borda); color: var(--tx-2); background-color: var(--cartao)">
        Fechar
      </button>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════ -->
<!-- Modal Agendamento Rápido (horário livre do dia)              -->
<!-- ═══════════════════════════════════════════════════════════ -->
<div *ngIf="showEncaixeModal" class="fixed inset-0 z-50 flex items-center justify-center p-4"
  style="background-color: rgba(0,0,0,0.5)">
  <div class="w-full max-w-lg rounded-2xl shadow-xl overflow-hidden flex flex-col"
    style="background-color: var(--cartao); max-height: 90vh">

    <!-- Cabeçalho -->
    <div class="px-5 py-4 flex items-center justify-between"
      style="border-bottom: 1px solid var(--flua-borda); background-color: var(--brand-surface)">
      <div class="flex items-center gap-2">
        <button *ngIf="agendaEncaixeSelecionada && !encaixeSucesso" (click)="voltarAgendasEncaixe()" class="p-1 rounded"
          style="color: var(--brand-primary)" onmouseover="this.style.backgroundColor='var(--brand-tint)'"
          onmouseout="this.style.backgroundColor='transparent'">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
            class="size-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>
        </button>
        <p class="font-semibold text-sm" style="color: var(--tx)">
          {{ agendaEncaixeSelecionada ? 'Horários Disponíveis' : 'Agendamento Rápido' }}
        </p>
      </div>
      <button (click)="fecharModalEncaixe()" [disabled]="isAgendandoEncaixe" class="p-1 rounded" style="color: var(--tx-2)"
        onmouseover="this.style.backgroundColor='var(--brand-tint)'" onmouseout="this.style.backgroundColor='transparent'">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Conteúdo -->
    <div class="flex-1 overflow-y-auto">

      <!-- Mensagem de sucesso -->
      <div *ngIf="encaixeSucesso" class="flex flex-col items-center justify-center py-12 px-6 gap-3 text-center">
        <div class="w-14 h-14 rounded-full flex items-center justify-center" style="background-color: #dcfce7">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#16a34a"
            class="size-8">
            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
          </svg>
        </div>
        <p class="font-semibold text-base" style="color: var(--tx)">Agendado com sucesso!</p>
        <p class="text-sm" style="color: var(--tx-2)">{{ encaixeSucesso }}</p>
      </div>

      <!-- Loading agendas -->
      <div *ngIf="isLoadingAgendasEncaixe" class="flex justify-center py-10">
        <div class="h-7 w-7 animate-spin rounded-full border-4 border-gray-300"
          style="border-top-color: var(--brand-primary)"></div>
      </div>

      <!-- Lista de agendas -->
      <div *ngIf="!isLoadingAgendasEncaixe && !agendaEncaixeSelecionada && !encaixeSucesso">
        <!-- Filtro de agendas -->
        <div *ngIf="agendasEncaixe.length > 0" class="px-5 pt-4 pb-2">
          <div class="flex items-center gap-2 px-3 py-2 rounded-lg border"
            style="border-color: var(--flua-borda); background-color: var(--cartao)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="var(--tx-3)"
              class="size-4 flex-shrink-0">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
            </svg>
            <input type="text" [(ngModel)]="filtroAgenda" placeholder="Filtrar por médico ou agenda..."
              class="flex-1 bg-transparent text-sm outline-none" style="color: var(--tx)" />
            <button *ngIf="filtroAgenda" (click)="filtroAgenda = ''" class="flex-shrink-0" style="color: var(--tx-3)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        <div *ngIf="agendasEncaixe.length === 0" class="flex flex-col items-center py-10 gap-2" style="color: var(--tx-2)">
          <p class="text-sm">Nenhuma agenda encontrada para hoje.</p>
        </div>
        <div *ngIf="agendasEncaixeFiltradas.length === 0 && agendasEncaixe.length > 0"
          class="flex flex-col items-center py-10 gap-2" style="color: var(--tx-2)">
          <p class="text-sm">Nenhuma agenda encontrada para "{{ filtroAgenda }}".</p>
        </div>
        <div *ngIf="agendasEncaixeFiltradas.length > 0" class="divide-y" style="border-color: var(--flua-borda)">
          <div *ngFor="let ag of agendasEncaixeFiltradas" (click)="selecionarAgendaEncaixe(ag)"
            class="px-5 py-3 flex items-center gap-3 cursor-pointer transition-colors"
            onmouseover="this.style.backgroundColor='var(--brand-surface)'" onmouseout="this.style.backgroundColor='transparent'">
            <div class="flex-1">
              <p class="font-semibold text-sm" style="color: var(--tx)">{{ ag.nmMedico }}</p>
              <p class="text-xs mt-0.5" style="color: var(--tx-2)">{{ ag.dsAgenda }}<span *ngIf="ag.isParceiro"> · parceiro</span></p>
            </div>
            <div class="flex items-center gap-2">
              <span *ngIf="ag.isOnline === 1"
                class="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-green-100 text-green-700">Online</span>
              <span class="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-purple-100 text-purple-700">
                {{ ag.qtAgendados }} agendados
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="#9AA6AF" class="size-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading slots -->
      <div *ngIf="isLoadingSlotsDisponiveis" class="flex justify-center py-10">
        <div class="h-7 w-7 animate-spin rounded-full border-4 border-gray-300"
          style="border-top-color: var(--brand-primary)"></div>
      </div>

      <!-- Lista de slots disponíveis -->
      <div *ngIf="agendaEncaixeSelecionada && !isLoadingSlotsDisponiveis && !encaixeSucesso">
        <!-- Agenda escolhida -->
        <div class="px-5 py-3 flex items-center gap-3" style="border-bottom: 1px solid var(--flua-borda)">
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2 flex-wrap">
              <p class="font-semibold text-sm truncate" style="color: var(--tx)">{{ agendaEncaixeSelecionada.nmMedico }}</p>
              <span *ngIf="agendaEncaixeSelecionada.isParceiro" class="encaixe-selo">parceiro</span>
            </div>
            <p class="text-xs mt-0.5 truncate" style="color: var(--tx-2)">{{ agendaEncaixeSelecionada.dsAgenda }}</p>
          </div>
          <span *ngIf="slotsDisponiveis.length > 0" class="encaixe-contagem">
            {{ horariosEncaixe.livres }} {{ horariosEncaixe.livres === 1 ? 'horário livre' : 'horários livres' }}
          </span>
        </div>

        <div *ngIf="encaixeErro" class="mx-5 my-3 px-3 py-2 rounded-lg text-sm"
          style="background-color: #fef2f2; color: #991b1b; border: 1px solid #fecaca">
          {{ encaixeErro }}
        </div>

        <div *ngIf="slotsDisponiveis.length === 0 && !encaixeErro" class="flex flex-col items-center py-10 gap-2"
          style="color: var(--tx-2)">
          <p class="text-sm">Nenhum horário disponível nesta agenda.</p>
        </div>

        <div *ngIf="slotsDisponiveis.length > 0" class="px-5 py-4 flex flex-col gap-4">
          <p *ngIf="horariosEncaixe.grupos.length === 0" class="text-sm text-center py-6" style="color: var(--tx-2)">
            Os horários livres desta agenda já passaram.
          </p>

          <div *ngFor="let grupo of horariosEncaixe.grupos">
            <p class="encaixe-periodo">{{ grupo.periodo }} <span>· {{ grupo.slots.length }}</span></p>
            <div class="encaixe-grade" role="radiogroup" [attr.aria-label]="'Horários da ' + grupo.periodo">
              <button *ngFor="let slot of grupo.slots" type="button" role="radio"
                class="encaixe-chip" [class.selecionado]="slotEncaixeSelecionado === slot"
                [attr.aria-checked]="slotEncaixeSelecionado === slot"
                [disabled]="isAgendandoEncaixe" (click)="slotEncaixeSelecionado = slot">
                {{ slot.hrAgenda }}
              </button>
            </div>
          </div>

          <button *ngIf="horariosEncaixe.anteriores > 0" type="button" (click)="alternarHorariosAnteriores()"
            class="self-start text-xs font-medium" style="color: var(--brand-primary)">
            {{ mostrarHorariosAnteriores ? 'Ocultar horários anteriores' : 'Mostrar horários anteriores (' + horariosEncaixe.anteriores + ')' }}
          </button>
        </div>
      </div>

    </div>

    <!-- Rodapé -->
    <div class="px-5 py-3 flex justify-end gap-2" style="border-top: 1px solid var(--flua-borda); background-color: var(--brand-surface)">
      <button type="button" (click)="fecharModalEncaixe()" [disabled]="isAgendandoEncaixe"
        class="px-5 py-2 rounded-lg text-sm font-medium"
        style="border: 1px solid var(--flua-borda); color: var(--tx-2); background-color: var(--cartao)">
        Fechar
      </button>
      <button *ngIf="agendaEncaixeSelecionada && !encaixeSucesso && slotsDisponiveis.length > 0" type="button"
        (click)="confirmarEncaixeSelecionado()" [disabled]="!slotEncaixeSelecionado || isAgendandoEncaixe"
        class="px-5 py-2 rounded-lg text-sm font-semibold text-white flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        style="background-color: var(--brand-primary)">
        <span *ngIf="isAgendandoEncaixe" class="h-4 w-4 animate-spin rounded-full border-2 border-white/40"
          style="border-top-color: white"></span>
        <ng-container *ngIf="isAgendandoEncaixe">Agendando...</ng-container>
        <ng-container *ngIf="!isAgendandoEncaixe">
          {{ slotEncaixeSelecionado ? 'Confirmar agendamento às ' + slotEncaixeSelecionado.hrAgenda : 'Escolha um horário' }}
        </ng-container>
      </button>
    </div>

  </div>
</div>

<app-cadastro-paciente-modal [aberto]="showCadastroPaciente" [cpfInicial]="cadastroCpfInicial" [clinicId]="clinicId"
  (fechar)="showCadastroPaciente = false" (cadastrado)="onPacienteCadastrado($event)"></app-cadastro-paciente-modal>

<app-termos-pav-modal *ngIf="mostrarTermos && selectedPassword?.personId" [cdPessoaFisica]="selectedPassword.personId"
  (fechar)="mostrarTermos = false"></app-termos-pav-modal>
